// Auto-generated Simplified Chinese (zh-CN) locale — machine-translated
// from en.ts (gpt-4o-mini), placeholders preserved. Refine by hand.
export default {
  "appTitle": "Terminus",
  "newThesis": "新解决方案线",
  "addThesis": "添加解决方案线",
  "titlePlaceholder": "解决方案线标题",
  "descriptionPlaceholder": "您解决方案线的简要描述",
  "cancel": "取消",
  "add": "添加",
  "confirmDelete": "确认删除",
  "deleteThesisQuestion": "您确定要删除此解决方案线吗？",
  "deleteAction": "删除",
  "done": "完成",
  "thesisCreated": "新解决方案线已创建",
  "thesisAdded": "解决方案线已添加",
  "thesisAddedDesc": "您的新解决方案线已成功添加。",
  "markDone": "标记精炼为完成",
  "refinementComplete": "精炼完成",
  "typePlaceholder": "输入反馈以精炼解决方案...",
  "connected": "已连接",
  "disconnected": "已断开连接",
  "newMessage": "新消息",
  "generatedSolutions": "生成的解决方案",
  "refineSolutions": "精炼解决方案",
  "refineShort": "精炼",
  "refiningSolutions": "正在精炼解决方案",
  "refiningSolutionsDesc": "您的反馈正在用于精炼研究解决方案。",
  "send": "发送",
  "regularMessage": "常规消息",
  "error": "错误",
  "unknownError": "发生未知错误",
  "status": {
    "draft": "草稿",
    "submitted": "已提交",
    "in_progress": "进行中",
    "running": "运行中",
    "done": "已完成",
    "published": "已发布",
    "completed": "已完成",
    "validated": "已验证",
    "waiting_validation": "待验证",
    "rejected": "已拒绝",
    "in_committee": "在委员会中",
    "approved": "已批准",
    "has_project": "有项目",
    "closed": "已关闭",
    "failed": "失败",
    "tooltips": {
      "draft": "草稿 - 等待处理",
      "submitted": "已提交 - 等待审核",
      "in_progress": "进行中 - 处理中",
      "running": "运行中 - 当前处理中",
      "done": "已完成 - 完成",
      "published": "已发布 - 对申请者可见",
      "completed": "已完成",
      "validated": "已验证 - 准备使用",
      "in_committee": "在委员会中 - 正在审核",
      "approved": "已批准",
      "has_project": "有项目 - 项目已生成",
      "closed": "已关闭",
      "failed": "失败 - 遇到错误"
    }
  },
  "actions": {
    "edit": "编辑",
    "cancel": "取消",
    "processFiles": "处理文件",
    "viewDetails": "查看详情",
    "viewReport": "查看报告",
    "download": "下载",
    "generateBrief": "生成简报",
  },
  "roles": {
    "entrepreneur": "企业家"
  },
  "opportunityStages": {
    "draft": "草稿",
    "pending": "待定",
    "inCommittee": "委员会中",
    "approved": "已批准",
    "inAssembly": "装配中",
    "inLead": "线索中",
    "hasProject": "有项目",
    "rejected": "已拒绝"
  },
  "filters": {
    "vertical": "垂直",
    "selectVertical": "选择垂直",
    "allVerticals": "所有垂直",
    "enterprise": "企业",
    "consumer": "消费者",
    "b2b": "B2B",
    "b2c": "B2C",
    "dateRange": "日期范围",
    "selectDateRange": "选择日期范围",
    "allTime": "所有时间",
    "lastWeek": "上周",
    "lastMonth": "上个月",
    "lastQuarter": "上个季度",
    "lastYear": "去年",
    "resetFilters": "重置过滤器",
    "clear": "清除过滤器",
    "type": "类型",
    "sector": "行业",
    "urgency": "紧急程度",
    "none": "未配置过滤器。",
    "regulatory": "监管",
    "sourceType": "来源",
    "technology": "技术",
    "horizon": "时间范围",
    "region": "地区",
    "sortBy": "排序方式",
    "sort": "排序",
    "sortOptions": {
      "newest": "最新优先",
      "oldest": "最早优先",
      "titleAsc": "名称 A → Z",
      "titleDesc": "名称 Z → A",
      "urgencyDesc": "紧急程度最高",
      "solutionsDesc": "解决方案最多",
      "priorityDesc": "优先级最高",
      "priorityAsc": "优先级最低",
      "applicantsDesc": "申请者最多",
      "filesDesc": "文件最多",
      "opportunitiesDesc": "机会最多"
    },
    "urgencyOptions": {
      "any": "任意紧急程度",
      "critical": "紧急",
      "high": "高",
      "medium": "中",
      "low": "低",
      "none": "无紧急程度"
    }
  },
  "discovery": {
    "title": "发现",
    "subtitle": "通过每日源监控浮现的新兴初创公司。",
    "items": "项",
    "empty": "没有可显示的内容。",
    "view": "查看",
    "filters": "过滤器",
    "filtersStatus": "状态",
    "filtersKind": "种类",
    "filtersSector": "行业",
    "filtersSource": "来源",
    "clearFilters": "清除所有过滤器",
    "search": "搜索发现...",
    "kindNew": "新",
    "kindTracked": "跟踪",
    "statusPending": "待定",
    "statusApproved": "已批准",
    "statusRejected": "已拒绝",
    "approve": "批准",
    "dismiss": "驳回",
    "ingestingTitle": "正在导入 {{name}}",
    "approveSuccess": "已批准 {{name}} — 正在生成档案",
    "approveError": "批准失败",
    "dismissSuccess": "已驳回 {{name}}",
    "dismissError": "驳回失败",
    "viewInDealflow": "在 DealFlow 中查看",
    "companyIdentity": "公司",
    "noSummary": "没有可用的摘要。",
    "generating2D": "正在生成 2D 分析…",
    "problemMarket": "问题与市场",
    "businessExecution": "商业与执行",
    "source": "来源",
    "origin": "起源",
    "article": "文章",
    "sourceArticle": "来源文章",
    "discovered": "发现",
    "location": "位置",
    "stats": {
      "total": "总计",
      "pending": "待定",
      "approved": "已批准",
      "rejected": "已拒绝"
    },
    "sort": {
      "label": "排序方式",
      "newest": "最新优先",
      "oldest": "最旧优先",
      "nameAsc": "名称 A → Z",
      "nameDesc": "名称 Z → A"
    },
    "date": {
      "label": "日期",
      "all": "所有时间",
      "today": "今天",
      "yesterday": "昨天",
      "last3": "过去 3 天",
      "thisWeek": "本周",
      "lastWeek": "上周",
      "lastMonth": "上个月"
    }
  },
  "connecting": "连接中...",
  "connectionError": "连接错误",
  "reportTitle": "报告",
  "generatedReport": "根据您的精炼生成的报告",
  "exportPDF": "导出 PDF",
  "shareReport": "分享报告",
  "welcome": "欢迎来到 Terminus",
  "selectThesis": "从侧边栏选择一个现有的解决方案线或创建一个新的解决方案线以开始精炼您的想法。",
  "noTheses": "还没有解决方案线。点击侧边栏中的 + 按钮添加您的第一条解决方案线。",
  "thesisDeleted": "解决方案线已删除",
  "thesisDeletedDesc": "您的解决方案行已被删除。",
  "refinementCompleted": "优化完成",
  "refinementCompletedDesc": "您的解决方案行正在处理中。报告将很快准备好。",
  "notifications": {
    "title": "通知",
    "bell": "通知",
    "markAllRead": "标记全部为已读",
    "empty": "还没有通知",
    "viewAll": "查看所有通知",
    "pageTitle": "通知",
    "allNotifications": "所有通知",
    "unread": "未读",
    "read": "已读",
    "markAsRead": "标记为已读",
    "markAllAsRead": "全部标记为已读",
    "noNotifications": "没有通知",
    "noNotificationsDesc": "您已全部查看！没有新通知。",
    "noUnread": "没有未读通知",
    "noUnreadDesc": "您已阅读所有通知。",
    "filterByType": "按类型筛选",
    "allTypes": "所有类型",
    "types": {
      "system_alert": "系统警报",
      "action_required": "需要采取行动",
      "info": "信息",
      "application_status": "申请状态",
      "project_match": "项目匹配",
      "committee_assignment": "委员会指派"
    },
    "priority": {
      "high": "高",
      "medium": "中",
      "low": "低"
    },
    "tabs": {
      "all": "全部",
      "unread": "未读"
    },
    "refresh": "刷新"
  },
  "theme": "主题",
  "language": "语言",
  "light": "明亮",
  "dark": "黑暗",
  "system": "系统",
  "english": "英语",
  "spanish": "西班牙语",
  "thesisActions": {
    "addSolution": "添加解决方案",
    "addSolutionTooltip": "手动添加新解决方案",
    "generateSingleSolution": "生成单个解决方案",
    "generateSingleSolutionTooltip": "使用AI生成单个解决方案",
    "generateSolutionsBulk": "批量生成解决方案",
    "generateSolutionsBulkTooltip": "使用AI生成多个解决方案",
    "generateReport": "生成报告",
    "generateReportTooltip": "为此解决方案行生成报告"
  },
  "notFound": {
    "404": "404",
    "pageNotFound": "页面未找到。",
    "description": "您要查找的页面不存在或已被移动。",
    "goBack": "返回",
    "returnHome": "返回首页"
  },
  "errors": {
    "generic": "出现问题",
    "validationError": "提交的数据无效",
    "notFound": "请求的资源未找到",
    "unauthorized": "请登录以继续",
    "forbidden": "您没有权限访问此内容",
    "serverError": "服务器错误",
    "serverErrorMessage": "我们遇到技术困难。我们的团队已被通知。",
    "applicationError": "应用程序错误",
    "applicationErrorMessage": "此浏览器中出现问题。请再试一次。",
    "badRequest": "无效请求",
    "conflict": "此操作与现有数据冲突",
    "serviceUnavailable": "服务暂时不可用",
    "networkError": "网络错误",
    "checkConnection": "请检查您的互联网连接",
    "tryAgain": "再试一次",
    "goHome": "回到首页",
    "supportReference": "参考：{{requestId}}",
    "opportunityNotFound": "未找到机会",
    "saveFailed": "保存更改失败"
  },
  "createThesisForm": {
    "thesisTitle": "解决方案行标题",
    "enterThesisTitle": "输入解决方案行标题",
    "titleRequired": "解决方案行标题不能为空",
    "creating": "正在创建...",
    "createThesis": "创建解决方案行"
  },
  "createMarketInsightForm": {
    "title": "创建市场洞察",
    "nameLabel": "名称",
    "namePlaceholder": "输入市场洞察名称",
    "categoryLabel": "类别",
    "categoryPlaceholder": "选择一个类别",
    "createButton": "创建市场洞察",
    "fillAllFields": "请填写所有字段",
    "created": "市场洞察创建成功",
    "createFailed": "创建市场洞察失败"
  },
  "categories": {
    "all": "全部",
    "industryCategory": "行业类别"
  },
  "marketInsightTable": {
    "name": "名称",
    "status": "状态",
    "created": "已创建",
    "theses": "解决方案行",
    "opportunities": "机会",
    "fileName": "文件名",
    "actions": "操作",
    "searchPlaceholder": "搜索市场洞察...",
    "noInsightsFound": "未找到市场洞察",
    "noFiles": "没有文件"
  },
  "marketInsight": {
    "downloadingBrief": "正在准备简报...",
    "regenerate": "重新生成",
    "files": "文件",
    "opportunities": "机会",
    "references": "参考",
    "referencesTitle": "参考",
    "comprehensiveReport": "综合报告",
    "metadata": "元数据",
    "aiGenerated": "AI生成",
    "sectionSources": "本节的来源",
    "allReferences": "所有参考",
    "contents": "内容",
    "citations": "引用",
    "noBriefYet": "尚未生成简报",
    "runGenerateToCreate": "从标题运行生成器以生成简报。",
    "primaryResearch": "主要研究",
    "primaryResearchDesc": "{{count}} 个源文档已上传以供分析。",
    "noWebSources": "未引用任何网络来源。",
    "viewFullBibliography": "查看完整参考书目 ({{count}})",
    "unnamedStartup": "未命名的初创公司",
    "generatingOpportunityFrom": "正在从 {{name}} 生成机会…",
    "generateOpportunityFailed": "生成机会失败",
    "removeMatchFailed": "删除初创公司失败",
    "matchItemType": "匹配",
    "matchedStartups": "匹配的初创公司",
    "addStartup": "添加初创公司",
    "matchingInProgress": "正在匹配初创公司...",
    "noMatchedStartups": "尚未匹配到初创公司。",
    "manuallyAdded": "手动添加",
    "createOpportunity": "创建机会",
    "startupAttached": "初创公司已添加到匹配",
    "startupsAttached": "{{count}} 个初创公司已添加到匹配",
    "startupAttachFailed": "附加 {{count}} 个初创公司失败",
    "attachFailed": "附加初创公司失败",
    "attachPickerTitle": "将初创公司添加到匹配",
    "createNewStartup": "创建新创业公司",
    "sectionLabels": {
      "introduccion_ejecutiva": "介绍",
      "macrotendencias": "宏观趋势",
      "retos_estructurales": "挑战",
      "problemas_empresa": "问题",
      "tecnologias_emergentes": "技术",
      "prioridades_inversion": "投资",
      "relevancia_region": "相关性",
      "benchmark_china": "中国基准"
    }
  },
  "deleteConfirmationDialog": {
    "areYouSure": "您确定吗？",
    "defaultDescriptionWithName": "此操作无法撤消。这将永久删除{{itemType}} \"{{itemName}}\"。",
    "defaultDescriptionWithoutName": "此操作无法撤消。这将永久删除此{{itemType}}。",
    "itemTypes": {
        "project lead": "项目线索",
      "item": "项目",
      "thesis": "解决方案线",
      "market insight": "市场洞察",
      "user": "用户",
      "solution": "解决方案",
      "committee": "委员会",
      "opportunity": "机会",
      "startup": "初创企业"
    },
    "consequences": {
      "startup": "其分析、一页纸简介、文件、评论和搜索向量将被删除。创建它的发现条目会保留。",
      "committee": "其决策、评论和报告将被删除，以及它与机会和市场洞察的关联。机会、解决方案和项目线索本身会保留——项目线索只是不再引用此委员会。"
    }
  },
  "uploadMarketInsightForm": {
    "title": "上传市场洞察",
    "uploadButton": "上传报告",
    "uploadFailed": "文件上传失败"
  },
  "thesisSection": {
    "id": "ID",
    "solutions": "解决方案",
    "solution": "解决方案",
    "report": "报告",
    "success": "成功",
    "reportReady": "您的报告已准备好。"
  },
  "solutionList": {
    "noSolutions": "此解决方案线没有可用的解决方案。"
  },
  "thesisTable": {
    "thesis": "解决方案线",
    "status": "状态",
    "solutionsCount": "解决方案 #",
    "actions": "操作",
    "draft": "草稿",
    "openMenu": "打开菜单",
    "editName": "编辑名称",
    "noThesesFound": "未找到解决方案线。"
  },
  "itemInputDialog": {
    "add": "添加{{itemType}}",
    "saveChanges": "保存更改",
    "adding": "添加中...",
    "saving": "保存中..."
  },
  "solutionItem": {
    "edit": "编辑",
    "remove": "移除",
    "editTooltip": "编辑此解决方案",
    "removeTooltip": "移除此解决方案"
  },
  "sidebar": {
    "toggleSidebar": "切换侧边栏",
    "terminusButton": "terminus",
    "foundersHubButton": "创始人中心",
    "gaiaButton": "gaia",
    "documentationButton": "文档",
    "organizationButton": "组织",
    "superadminButton": "超级管理员",
    "marketInsights": "市场洞察",
    "viewAllMarketInsights": "查看所有市场洞察",
    "thesis": "解决方案线",
    "viewAllThesis": "查看所有解决方案线",
    "settings": "设置",
    "entrepreneur": {
      "overview": "概览",
      "opportunities": "机会",
      "myOpportunities": "我的想法",
      "sectors": "行业",
      "applications": "应用",
      "profile": "个人资料",
      "home": "首页"
    },
    "admin": {
      "researchCenter": "研究中心",
      "marketInsights": "市场洞察",
      "dealflow": "dealflow",
      "discovery": "发现",
      "opportunities": "机会",
      "validation": "验证",
      "projects": "项目",
      "committee": "委员会",
      "postCommittee": "后委员会",
      "projectLeads": "项目负责人",
      "shaping": "塑造",
      "archives": "档案",
      "clients": "客户"
    }
  },
  "allThesesView": {
    "title": "所有解决方案线 ({{count}})",
    "createNewThesis": "创建新解决方案线",
    "deleteThesis": "删除解决方案线",
    "thesisName": "解决方案线名称",
    "editThesis": "编辑解决方案线: {{title}}",
    "enterNewThesisName": "输入新的解决方案线名称"
  },
  "allOpportunitiesView": {
      "items": "条",
      "searchPlaceholder": "搜索机会...",
    "title": "机会 ({{count}})",
    "pageTitle": "机会",
    "subtitle": "带有问题定义和解决方案线的投资机会",
    "createOpportunity": "创建机会",
    "openMenu": "打开菜单",
    "deleteTitle": "删除机会",
    "errorLoading": "加载机会时出错: {{message}}",
    "stats": {
      "total": "总计",
      "totalDesc": "系统中机会的总数",
      "draft": "草稿",
      "draftDesc": "机会仍在定义或完善中",
      "pending": "待定",
      "approved": "已批准",
      "inAssembly": "装配中",
      "inLead": "线索中",
      "rejected": "已拒绝",
      "validated": "已验证",
      "validatedDesc": "已审核并批准投资的机会",
      "withTheses": "带有论点",
      "withThesesDesc": "定义了解决方案线（论点）的机会",
      "inCommittee": "在委员会中",
      "inCommitteeDesc": "与投资委员会会议相关的机会",
      "submitted": "已提交",
      "submittedDesc": "由企业家提交，待审核",
      "hasProject": "有项目",
      "hasProjectDesc": "已成为一个或多个项目的机会",
      "closed": "已关闭",
      "closedDesc": "委员会已关闭的机会",
      "timeToValidated": "验证时间",
      "timeToValidatedDesc": "从创建到验证的平均时间",
      "timeToCommittee": "委员会时间",
      "timeToCommitteeDesc": "从验证到委员会链接的平均时间",
      "timeToProject": "项目时间",
      "timeToProjectDesc": "从委员会链接到第一个项目的平均时间",
      "totalCycle": "周期时间",
      "totalCycleDesc": "从创建到第一个项目的平均端到端时间"
    },
    "types": {
      "label": "类型",
      "all": "任何类型",
      "marketInsight": "来自市场洞察",
      "entrepreneur": "企业家",
      "internal": "内部"
    },
    "legend": {
      "hoverForDetails": "悬停在指标上以获取详细信息",
      "urgencyScore": "紧迫性评分",
      "solutionLines": "解决方案线",
      "dataCompleteness": "数据完整性（问题 → ICP → 紧迫性 → 解决方案）"
    }
  },
  "allMarketInsightsView": {
      "progress": "进度",
      "filesCount_other": "{{count}} 个文件",
      "clear": "清除",
    "title": "市场洞察 ({{count}})",
    "pageTitle": "市场研究",
    "subtitle": "基于AI的行业文档分析用于市场研究",
    "createNew": "创建新市场洞察",
    "createTitle": "创建市场洞察",
    "uploadTitle": "上传市场洞察",
    "openMenu": "打开菜单",
    "deleteTitle": "删除市场洞察",
    "errorLoading": "加载市场洞察时出错: {{message}}",
    "stats": {
      "timeToRun": "运行时间",
      "timeToRunDesc": "从创建到处理开始的平均时间",
      "timeToCompletion": "完成时间",
      "timeToCompletionDesc": "从处理开始到报告完成的平均时间",
      "webResearchPct": "% 网络研究",
      "webResearchPctDesc": "来自网络研究的文件与上传文件的平均比例"
    }
  },
  "marketInsightSidebar": {
    "title": "市场洞察详情",
    "uploadDocuments": "上传文档",
    "uploading": "上传中",
    "uploadedFiles": "已上传文件",
    "analysisFilters": "分析过滤器",
    "startProcessing": "开始处理",
    "startingProcessing": "正在开始处理...",
    "viewFullPage": "查看完整页面",
    "processingStarted": "处理已开始",
    "processingStartedDesc": "市场洞察正在处理",
    "processingFailed": "启动处理失败",
    "uploadFileRequired": "请上传至少一个文件以继续",
    "completeRequiredFields": "完成所有必填过滤字段（标记为*）",
    "noSelection": "未选择市场洞察",
    "opportunities": "机会",
    "opportunitiesGenerated": "已生成"
  },
  "marketInsightProcessing": {
      "failed": "处理失败",
    "title": "处理市场洞察",
    "description": "正在分析文档并生成上下文摘要...",
    "statusProcessing": "正在生成机会和洞察",
    "pleaseWait": "请稍候，这可能需要几分钟...",
    "tryAgain": "再试一次"
  },
  "marketInsightView": {
    "success": "成功",
    "notFound": "未找到市场洞察",
    "loadFailed": "加载市场洞察失败",
    "processFiles": "处理文件",
    "overview": "概览",
    "files": "文件",
    "opportunities": "机会",
    "filters": "过滤器",
    "overviewTitle": "市场洞察概览",
    "filesCount": "文件",
    "opportunitiesCount": "机会",
    "thesesCount": "解决方案线",
    "fileManagement": "文件管理",
    "selectFile": "选择文件",
    "upload": "上传",
    "uploading": "上传中...",
    "selectedFile": "已选择文件",
    "fileUploaded": "文件上传成功",
    "uploadFailed": "文件上传失败",
    "processingStarted": "处理已开始",
    "processingFailed": "启动处理失败",
    "noFiles": "尚未上传文件",
    "noOpportunities": "尚未生成机会",
    "theses": "解决方案线",
    "noFilters": "未应用过滤器",
    "notSelected": "未选择市场洞察或解决方案线。",
    "solutionAdded": "解决方案添加成功。",
    "solutionUpdated": "解决方案更新成功。",
    "solutionFailed": "未能{{action}}解决方案。{{message}}",
    "add": "添加",
    "update": "更新",
    "notSelectedForGeneration": "未选择市场洞察或解决方案线以生成解决方案。",
    "solutionGenerationInitiated": "解决方案生成已启动。",
    "generateSolutionFailed": "生成解决方案失败。{{message}}",
    "solutionRemoved": "解决方案删除成功。",
    "removeSolutionFailed": "删除解决方案失败。{{message}}",
    "notSelectedForReportGeneration": "未选择市场洞察或解决方案线以生成报告。",
    "reportGenerationInitiated": "报告生成已启动。",
    "generateReportFailed": "生成报告失败。{{message}}",
    "notSelectedForSolutionsGeneration": "未选择市场洞察或解决方案线以生成解决方案。",
    "allSolutionsGenerationInitiated": "已为解决方案线启动所有解决方案生成。",
    "generateSolutionsFailed": "生成解决方案失败。{{message}}",
    "solution": "解决方案",
    "report": "报告",
    "solutionItemType": "解决方案",
    "addNewSolution": "添加新解决方案",
    "editSolution": "编辑解决方案",
    "enterSolutionText": "输入解决方案文本"
  },
  "verifyEmail": {
    "title": "验证您的电子邮件",
    "sentTo": "我们已向{{email}}发送验证链接",
    "verified": "电子邮件已验证",
    "verifiedDesc": "您的电子邮件已成功验证。正在重定向...",
    "continue": "继续申请审核",
    "expired": "此验证链接已过期。请请求一个新的。",
    "invalid": "此验证链接无效。请请求一个新的。",
    "sendFailed": "发送验证电子邮件失败。请再试一次。",
    "step1Title": "检查您的收件箱",
    "step1Desc": "我们已向您的电子邮件地址发送验证链接。",
    "step2Title": "点击链接",
    "step2Desc": "打开电子邮件并点击验证链接。",
    "step3Title": "获取验证",
    "step3Desc": "一旦验证，您的申请将继续审核。",
    "resend": "重新发送验证电子邮件",
    "resendIn": "{{seconds}}秒后重新发送",
    "checkSpam": "没有收到电子邮件？检查您的垃圾邮件文件夹或联系我们"
  },
  "waitingPage": {
    "title": "申请审核中",
    "description": "感谢您提交您的个人资料！我们的团队正在审核您的申请。",
    "profileSubmitted": "个人资料已提交",
    "profileSubmittedDesc": "您的申请已成功提交以供审核。",
    "underReview": "审核中",
    "underReviewDesc": "我们的团队正在审核您的申请。这通常需要1-2个工作日。",
    "emailNotification": "电子邮件通知",
    "emailNotificationDesc": "一旦处理您的申请，您将收到一封电子邮件，发送至<strong>{{email}}</strong>。",
    "whatHappensNext": "接下来会发生什么？",
    "nextSteps": {
      "step1": "我们的团队分析您的工作背景和技能，以了解您的创业潜力。",
      "step2": "在1-2个工作日内，您将获得批准及访问详情或改善您个人资料的建议。",
      "step3": "一旦获得批准，您将完全访问terminus。"
    },
    "contactUs": "有问题吗？请联系我们"
  },
  "consentPage": {
    "tagline": "在我们开始之前",
    "title": "条款与同意。",
    "subtitle": "请审阅并接受以下协议以继续。",
    "termsLabel": "我已阅读并接受<termsLink>服务条款</termsLink>，该条款适用于平台的使用",
    "privacyLabel": "我已阅读并接受<privacyLink>隐私政策</privacyLink>，了解我的个人数据如何处理",
    "communicationsLabel": "我希望接收与我的个人资料相关的生态系统更新、活动和机会",
    "communicationsOptional": "(可选)",
    "continueButton": "接受并继续",
    "submitting": "处理中...",
    "mandatoryRequired": "您必须接受服务条款和隐私政策才能继续。",
    "termsUrl": "/terms",
    "privacyUrl": "/privacy"
  },
  "legalPage": {
    "termsTitle": "服务条款。",
    "privacyTitle": "隐私政策。",
    "loading": "加载文档...",
    "error": "加载文档失败。请再试一次。",
    "retry": "重试",
    "courtesyNotice": "这是一个礼貌翻译。具有法律约束力的版本为西班牙语。",
    "back": "返回"
  },
  "onboardingPage": {
    "title": "完善您的个人资料",
    "stepProgress": "第{{current}}步，共{{total}}步 - 帮助我们更好地了解您",
    "linkedInConnected": "LinkedIn 个人资料已连接",
    "linkedInConnectedDesc": "信息已从您的 LinkedIn 个人资料中预填。请审阅并根据需要更新。",
    "cvUpdateBanner": "如果您的 LinkedIn 数据不完整或过时，您可以上传您的简历以更新您的个人资料。",
    "cvUpdateButton": "上传简历",
    "cvUpdateParsing": "正在读取您的简历...",
    "cvUpdateSuccess": "简历解析成功！您的个人资料已更新。",
    "step0": {
      "title": "自动填充 LinkedIn 个人资料",
      "subtitle": "通过让我们读取您的 LinkedIn 职业信息来加快您的入职流程",
      "urlLabel": "LinkedIn 个人资料 URL",
      "urlPlaceholder": "linkedin.com/in/yourname",
      "urlHelp": "分享您的 LinkedIn 个人资料 URL，以自动填写您的职业信息",
      "buttonIdle": "自动填充我的个人资料",
      "buttonStarting": "开始...",
      "buttonReading": "正在读取您的个人资料... {{progress}}%",
      "buttonUnderstanding": "正在理解您的个人资料...",
      "progressStarting": "开始...",
      "progressReading": "正在读取您的个人资料...",
      "progressProcessing": "处理中...",
      "errorTitle": "出现问题：",
      "linkedinErrorTitle": "我们无法读取您的 LinkedIn 个人资料。",
      "linkedinErrorDescription": "如果个人资料是私密的或暂时不可用，可能会发生这种情况。您可以再试一次或手动上传您的简历。",
      "tryAgain": "再试一次",
      "uploadCvInstead": "改为上传您的简历",
      "cvUploadTitle": "上传您的简历。",
      "cvUploadSubtitle": "上传您的简历，我们将自动提取您的职业信息。",
      "cvDropzone": "将您的简历拖放到此处，或单击浏览",
      "cvAcceptedFormats": "接受的格式：PDF，DOCX，MD（最大10MB）",
      "cvUploading": "正在上传您的简历...",
      "cvParsing": "正在读取您的简历...",
      "cvParseError": "解析您的简历失败。请尝试使用不同的文件。",
      "backToLinkedin": "尝试使用 LinkedIn",
      "howItWorksTitle": "它是如何工作的：",
      "howItWorks1": "我们将读取您的公开个人资料信息",
      "howItWorks2": "您的工作经验、教育和技能将自动填写",
      "howItWorks3": "您可以在提交之前审阅和编辑所有内容",
      "howItWorks4": "这将为您节省5-10分钟的手动数据输入时间"
    },
    "step1": {
      "title": "审阅您的信息",
      "titleWithName": "看起来不错，{{name}}",
      "subtitle": "审阅并编辑您的基本信息",
      "firstName": "名字",
      "firstNamePlaceholder": "输入您的名字",
      "lastName": "姓氏",
      "lastNamePlaceholder": "输入您的姓氏",
      "location": "位置",
      "locationPlaceholder": "例如，旧金山，加州",
      "headline": "职业头衔",
      "headlinePlaceholder": "例如，TechCorp 的创始人兼首席执行官",
      "industry": "行业",
      "industryPlaceholder": "例如，技术、医疗、金融",
      "summary": "职业总结",
      "summaryPlaceholder": "您职业背景的简要总结..."
    },
    "step2": {
      "title": "工作经验",
      "subtitle": "添加您的职业经历",
      "workExperienceLabel": "工作经验",
      "sameCompany": "(同一公司)",
      "jobTitle": "职位名称",
      "jobTitlePlaceholder": "例如，高级软件工程师",
      "company": "公司",
      "companyPlaceholder": "例如，谷歌",
      "location": "位置",
      "locationPlaceholder": "例如，旧金山，加州",
      "startMonth": "开始月份",
      "startYear": "开始年份",
      "endMonth": "结束月份",
      "endYear": "结束年份",
      "currentlyWork": "我目前在这里工作",
      "description": "描述",
      "descriptionPlaceholder": "描述您的职责和成就...",
      "addWorkExperience": "添加工作经验",
      "role": "角色",
      "roles": "角色"
    },
    "step3": {
      "title": "教育",
      "subtitle": "添加您的教育背景",
      "educationLabel": "教育",
      "school": "学校",
      "schoolPlaceholder": "例如，斯坦福大学",
      "degree": "学位",
      "degreePlaceholder": "例如，理学学士",
      "fieldOfStudy": "专业领域",
      "fieldOfStudyPlaceholder": "例如，计算机科学",
      "startYear": "开始年份",
      "endYear": "结束年份",
      "description": "描述",
      "descriptionPlaceholder": "活动、社团、荣誉等...",
      "addEducation": "添加教育"
    },
    "step4": {
      "title": "认证与技能",
      "subtitle": "添加认证和技能",
      "certificationsLabel": "认证",
      "certificationLabel": "认证",
      "certName": "名称",
      "certNamePlaceholder": "例如，AWS 解决方案架构师",
      "certAuthority": "颁发机构",
      "certAuthorityPlaceholder": "例如，亚马逊网络服务",
      "certLicense": "许可证号码",
      "certLicensePlaceholder": "可选",
      "certUrl": "网址",
      "certUrlPlaceholder": "例如，https://...",
      "certStartMonth": "开始月份",
      "certStartYear": "开始年份",
      "certEndMonth": "结束月份（如果过期）",
      "certEndYear": "结束年份",
      "addCertification": "添加认证",
      "skillsLabel": "技能",
      "skillPlaceholder": "例如，JavaScript、项目管理等。",
      "addSkill": "添加技能"
    },
    "step5": {
      "title": "语言与审核",
      "subtitle": "添加语言并审核您的个人资料",
      "languagesLabel": "语言",
      "languageName": "语言（例如，英语、西班牙语）",
      "languageProficiency": "熟练程度（例如，母语、流利）",
      "addLanguage": "添加语言",
      "reviewTitle": "准备提交",
      "reviewDesc": "您的个人资料已完成。提交以继续申请。",
      "noLanguages": "未添加语言"
    },
    "steps": {
      "import": "导入",
      "profile": "个人资料",
      "experience": "经验",
      "complete": "完成"
    },
    "proficiency": {
      "native": "母语",
      "fluent": "流利",
      "professional": "专业",
      "intermediate": "中级",
      "basic": "基础"
    },
    "optional": "可选",
    "noExperience": "尚未添加经验",
    "noEducation": "尚未添加教育",
    "present": "现在",
    "validation": {
      "firstNameRequired": "必填名",
      "lastNameRequired": "必填姓",
      "headlineRequired": "必填标题",
      "emptyWorkExperience": "删除空的工作经验条目或填写它们",
      "jobTitleRequired": "所有工作经验条目都需要职位名称",
      "companyRequired": "所有工作经验条目都需要公司名称",
      "schoolRequired": "所有教育条目都需要学校名称",
      "languageNameRequired": "所有语言条目都需要语言名称",
      "certNameRequired": "所有认证条目都需要认证名称",
      "locationRequired": "位置是必填项",
      "startDateRequired": "开始日期是必填项",
      "endDateRequired": "结束日期是必填项",
      "endDateBeforeStart": "结束日期不能早于开始日期",
      "fixErrors": "请在继续之前修正上述错误"
    },
    "back": "返回",
    "next": "下一步",
    "continue": "继续",
    "submitting": "提交中...",
    "submitForReview": "提交审核",
    "platformTagline": "为企业家提供的平台机会。",
    "toastUrlSubmitted": "LinkedIn 网址已提交！正在读取您的个人资料...",
    "toastAutocompleted": "LinkedIn 个人资料已成功自动完成！",
    "toastInvalidUrl": "请输入有效的 LinkedIn 个人资料网址（例如，linkedin.com/in/yourname）",
    "toastSubmitFailed": "提交 LinkedIn 网址失败",
    "toastProfileSubmitted": "个人资料已提交审核！",
    "toastLoginAgain": "请重新登录以提交您的个人资料",
    "toastProfileFailed": "提交个人资料失败：{{error}}"
  },
  "linkedInParsing": {
    "title": "正在读取您的 LinkedIn 个人资料",
    "description": "我们正在读取您的 LinkedIn 个人资料以了解您的专业背景。此过程通常需要 20-30 秒。",
    "progressComplete": "{{progress}}% 完成",
    "estimatedTime": "预计剩余时间：{{seconds}} 秒",
    "statusStarting": "开始...",
    "statusConnecting": "连接到 LinkedIn...",
    "statusReading": "正在读取您的个人资料...",
    "statusUnderstanding": "了解您的工作经验和教育...",
    "statusReviewing": "审核您的技能和认证...",
    "statusAlmostDone": "快完成了...",
    "pleaseWait": "请稍候，请勿关闭此窗口",
    "tryAgain": "重试"
  },
  "entrepreneurStatus": {
    "PENDING_LINKEDIN_PARSE": "待处理 LinkedIn",
    "PENDING_ONBOARDING": "待处理入职",
    "PENDING_SUMMARY": "审核中",
    "PENDING_PASSED_PRESCORE": "通过预评分",
    "PENDING_FAILED_PRESCORE": "未通过预评分",
    "PENDING_WITH_NOTES": "审核进行中",
    "APPROVED": "已批准",
    "REJECTED": "已拒绝",
    "REJECTED_FAILED_PRESCORE": "已拒绝 - 未通过预评分",
    "SUSPENDED": "已暂停",
    "DELETED": "已删除"
  },
  "entrepreneurDashboard": {
    "welcome": "欢迎回来，{{name}}",
    "activitySummary": "这是您的活动摘要",
    "pendingOpportunities": {
      "title": "为您提供的机会",
      "emptyTitle": "尚无机会",
      "emptyState": "我们正在积极策划与您的独特个人资料和专业知识相匹配的机会"
    },
    "recommendedOpportunities": "推荐机会",
    "viewAllOpportunities": "查看全部",
    "noOpportunities": "尚无机会",
    "noOpportunitiesDesc": "我们正在为您寻找最佳机会。请稍后再回来查看！",
    "stats": {
      "total": "总计",
      "quickWins": "快速胜利",
      "strategic": "战略",
      "avgMatch": "平均匹配"
    },
    "sectors": {
      "title": "行业",
      "viewAll": "查看全部",
      "opportunity": "机会",
      "opportunities": "机会"
    },
    "applications": {
      "title": "我的申请",
      "viewAll": "查看全部",
      "noApplications": "尚无申请",
      "noApplicationsDesc": "当您申请机会时，它们将出现在这里，以便您跟踪状态。"
    },
    "card": {
      "details": "详情",
      "apply": "申请",
      "priority": "优先级",
      "match": "匹配"
    }
  },
  "entrepreneurOpportunityDetail": {
    "opportunityNotFound": "未找到机会",
    "applyNow": "立即申请",
    "applicationFeatureComingSoon": "申请功能即将推出",
    "scores": {
      "priority": "优先级",
      "match": "匹配",
      "urgency": "紧急性",
      "difficulty": "难度"
    },
    "whyWeRecommend": {
      "title": "我们推荐此项的原因",
      "experienceRelevant": "您在 {{sector}} 的经验非常相关",
      "rolesMatch": "您的角色与我们所寻找的匹配",
      "skillsAlign": "您的技能与项目要求相符"
    },
    "tabs": {
      "summary": "摘要",
      "detail": "细节",
      "requirements": "我们寻找的内容",
      "faq": "常见问题"
    },
    "summary": {
      "noDescription": "没有可用的描述。",
      "vertical": "垂直",
      "duration": "持续时间",
      "experience": "经验",
      "yearsPlus": "{{years}}+ 年"
    },
    "detail": {
      "problemContext": "问题 / 背景",
      "solutionProposal": "解决方案提案",
      "scopeDeliverables": "范围与交付物",
      "noDetails": "没有可用的额外细节。"
    },
    "requirements": {
      "targetRoles": "目标角色",
      "noRoles": "没有列出具体角色。",
      "minimumSeniority": "最低资历",
      "experienceRequired": "{{years}}+ 年的经验要求",
      "openToAll": "对所有经验水平开放",
      "noRequirements": "此机会没有列出具体要求。"
    },
    "faq": {
      "selectionProcess": {
        "question": "选择过程是什么？",
        "answer": "选择过程包括几个阶段：初步申请审核、技术面试以评估您的经验和方法、解决方案提案的展示，以及委员会的最终评估。整个过程通常需要 2-4 周。"
      },
      "support": {
        "question": "我将获得什么支持？",
        "answer": "被选中的企业家将获得全面支持，包括：访问客户的技术团队、专门的指导、潜在的试点资金，以及与我们投资者和行业合作伙伴网络的联系。"
      },
      "timeCommitment": {
        "question": "时间承诺是什么？",
        "answer": "这取决于项目范围，但通常在初始开发阶段需要全职投入。我们与企业家合作，建立双方都能接受的明确里程碑和时间表。"
      },
      "afterApply": {
        "question": "我申请后会发生什么？",
        "answer": "提交申请后，我们的团队将审核您的个人资料和经验。如果合适，我们会联系您安排初步对话。您将通过仪表板收到申请状态的更新。"
      }
    }
  },
  "opportunityStatus": {
    "applied": "已申请",
    "accepted": "已接受",
    "rejected": "已拒绝",
    "saved": "已保存"
  },
  "matchedOpportunities": {
    "title": "匹配的机会",
    "description": "根据您的经验和专业知识与您的个人资料匹配的项目",
    "noMatches": "未找到匹配项",
    "noMatchesFiltered": "尝试调整您的筛选条件以查看更多机会。",
    "noMatchesDesc": "我们正在持续分析新项目。请稍后再回来查看个性化匹配。",
    "stats": {
      "total": "总匹配",
      "excellent": "优秀 (85%+)",
      "avgMatch": "平均匹配",
      "avgDomain": "平均领域适配"
    },
    "filters": {
      "label": "筛选条件",
      "status": "状态",
      "allStatus": "所有状态",
      "available": "可用",
      "saved": "已保存",
      "applied": "已申请",
      "minScore": "最低分数",
      "allScores": "所有分数",
      "excellent": "85%+ 优秀",
      "strong": "70%+ 强",
      "good": "55%+ 良好",
      "sector": "行业",
      "allSectors": "所有行业",
      "clear": "清除筛选条件"
    },
    "card": {
      "matchScore": "匹配",
      "domainFit": "领域",
      "executionFit": "执行",
      "save": "保存",
      "apply": "申请",
      "dismiss": "拒绝"
    }
  },
  "matchedOpportunityDetail": {
    "notFound": "未找到机会",
    "save": "保存",
    "apply": "申请",
    "dismiss": "拒绝此机会",
    "scores": {
      "match": "匹配分数",
      "domain": "领域适配",
      "execution": "执行适配",
      "urgency": "紧急性",
      "difficulty": "难度"
    },
    "whyMatched": {
      "title": "为什么这与您的个人资料匹配"
    },
    "riskFlags": {
      "title": "考虑因素"
    },
    "tabs": {
      "summary": "摘要",
      "detail": "项目详情",
      "requirements": "要求"
    },
    "summary": {
      "noDescription": "没有可用的描述。",
      "vertical": "垂直",
      "duration": "持续时间",
      "experience": "经验",
      "yearsPlus": "{{years}}+ 年"
    },
    "detail": {
      "problemContext": "问题背景",
      "solutionProposal": "解决方案提案",
      "scopeDeliverables": "范围与交付物",
      "noDetails": "没有可用的额外细节。"
    },
    "requirements": {
      "targetRoles": "目标角色",
      "noRoles": "未定义具体角色。",
      "minimumSeniority": "最低资历",
      "experienceRequired": "需要 {{years}} 年以上相关经验",
      "openToAll": "对所有经验水平开放"
    }
  },
  "entrepreneurIndustries": {
    "title": "行业",
    "subtitle": "按行业探索项目",
    "projectAvailable": "{{count}} 个项目可用",
    "projectsAvailable": "{{count}} 个项目可用",
    "noProjects": "没有可用项目",
    "sectorDescriptions": {
      "Energy": "能源生产和分配",
      "Aerospace": "航空航天和航空",
      "AgriTech": "农业技术",
      "TourismSmartCities": "旅游技术和智慧城市",
      "HealthBiotech": "医疗保健和生物技术",
      "AdvancedTransport": "先进运输和移动性",
      "AdvancedManufacturing": "先进制造和工业 5.0",
      "SustainableResources": "可持续资源和材料",
      "SmartInfrastructure": "智能基础设施和建筑",
      "FinTech": "金融科技",
      "InsurTech": "保险科技"
    }
  },
  "entrepreneurIndustryDetail": {
    "sectorTitle": "行业：{{sector}}",
    "sortBy": "排序方式",
    "sortOptions": {
      "relevance": "对我相关性",
      "priority": "优先级",
      "newest": "最新优先"
    },
    "noOpportunities": "该行业没有机会",
    "noOpportunitiesDesc": "稍后查看该行业的新机会。",
    "moreInfo": "+ 信息",
    "apply": "申请"
  },
  "entrepreneurApplications": {
    "title": "我的申请",
    "subtitle": "跟踪您的申请状态",
    "noApplications": "尚未提交申请",
    "noApplicationsDesc": "当您申请机会时，它们会出现在这里，以便您跟踪进度。",
    "browseOpportunities": "浏览机会",
    "appliedOn": "申请于 {{date}}",
    "viewDetails": "查看详情",
    "status": {
      "pending": "待审核",
      "accepted": "已接受",
      "rejected": "未被选中"
    }
  },
  "entrepreneurProfile": {
    "title": "我的个人资料",
    "subtitle": "您的专业资料和账户信息",
    "preScore": "预评分",
    "fullTime": "全职",
    "editProfile": "编辑个人资料",
    "cancelEdit": "取消",
    "saveProfile": "保存更改",
    "saving": "保存中...",
    "aboutMe": "关于我",
    "experience": "经验",
    "education": "教育",
    "skills": "技能",
    "languages": "语言",
    "certifications": "认证",
    "years": "年",
    "present": "现在",
    "sectorDistribution": "行业分布",
    "roleDistribution": "角色分布",
    "keywords": "关键词",
    "preferences": "偏好",
    "sectorsOfInterest": "感兴趣的行业",
    "availability": "可用性",
    "noSummary": "尚未添加摘要",
    "noExperience": "尚未添加经验",
    "noEducation": "尚未添加教育",
    "noSkills": "尚未添加技能",
    "noLanguages": "尚未添加语言",
    "noCertifications": "尚未添加认证"
  },
  "entrepreneur": {
    "myOpportunities": {
      "title": "我的想法。",
      "subtitle": "创建和管理您的想法",
      "create": "新想法",
      "empty": "您尚未创建任何想法。",
      "createFirst": "创建您的第一个想法",
      "submit": "提交审核"
    },
    "createOpportunity": {
      "title": "新机会。",
      "subtitle": "描述您所识别的商业机会",
      "createButton": "创建机会"
    },
    "opportunity": {
      "submitForReview": "提交审核",
      "submitted": "已提交",
      "overview": "概述",
      "process": "受影响的流程",
      "problem": "问题描述",
      "committee": "委员会"
    }
  },
  "marketInsightFilters": {
    "documentMetadata": "文档元数据",
    "businessThematicAxes": "商业主题轴",
    "geography": "地理",
    "regulationPolicies": "法规与政策",
    "technologyMaturity": "技术 / 成熟度",
    "sourceType": "来源类型",
    "sourceTypeOptions": {
      "strategicConsultant": "战略顾问",
      "fundInvestor": "基金/投资者",
      "specializedMedia": "专业媒体",
      "publicOrganization": "公共组织",
      "thinkTankNgo": "智库 / NGO",
      "operatingCompany": "运营公司",
      "academic": "学术"
    },
    "publicationDate": "出版日期",
    "publicationDatePresets": {
      "ytd": "年初至今",
      "last90Days": "过去 90 天",
      "last6Months": "过去 6 个月",
      "lastYear": "去年",
      "last2Years": "过去 2 年"
    },
    "analysisTemporalCoverage": "分析时间覆盖",
    "analysisTemporalCoverageOptions": {
      "historical": "历史",
      "range2025_2030": "2025-2030",
      "range2031_2040": "2031-2040",
      "beyond2040": ">2040"
    },
    "verticalSubsector": "垂直/子行业",
    "verticalSubsectorPlaceholder": "输入垂直或子行业",
    "region": "地区",
    "regionOptions": {
      "global": "全球",
      "eu27": "欧盟-27",
      "northAmerica": "北美",
      "latam": "拉美",
      "emea": "欧洲、中东和非洲",
      "apac": "亚太地区",
      "spain": "西班牙"
    },
    "includeRegulatoryFramework": "包括监管框架",
    "includeRegulatoryFrameworkOptions": {
      "yes": "是（提及具体法律框架）",
      "no": "否"
    },
    "regulationType": "监管类型",
    "regulationTypeOptions": {
      "euDirective": "欧盟指令",
      "euRegulation": "欧盟法规",
      "nationalLaw": "国家法律",
      "technicalStandard": "技术标准",
      "taxIncentive": "税收激励",
      "subsidyPublicFund": "补贴/公共基金"
    },
    "protagonistTechnology": "主角技术",
    "protagonistTechnologyPlaceholder": "输入主角技术（例如，AI，区块链）",
    "selectPlaceholder": "选择...",
    "fromDate": "从",
    "toDate": "到",
    "clearFilters": "清除所有筛选器",
    "applyFilters": "应用筛选器",
    "resetFilters": "重置筛选器"
  },
  "opportunities": {
      "generationFailed": "生成失败",
    "deleteFailed": "无法删除该机会",
    "deleteSolutionFailed": "无法删除该解决方案",
    "fromMarketInsight": "研究背景",
    "fromStartup": "来源初创公司",
    "startupContextDescription": "此机会是从该初创公司生成的。打开以查看其资料。",
    "audit": {
      "created": "创建于 {{date}}",
      "validated": "验证于 {{date}}",
      "validatedBy": "由 {{name}} 验证于 {{date}}",
      "decided": "决定于 {{date}}",
      "decidedBy": "由 {{name}} 决定于 {{date}}"
    },
    "noOpportunitiesFound": "未找到机会",
    "statusSubmitted": "已提交",
    "processFilesPrompt": "处理您上传的文件以生成市场机会。",
    "marketOpportunities": "市场机会 ({{count}})",
    "b2bAnalysis": "具有全面分析的 B2B 机会",
    "view": "查看",
    "edit": "编辑",
    "delete": "删除",
    "editOpportunity": "编辑机会",
    "deleteOpportunity": "删除机会",
    "validate": "验证",
    "devalidate": "从待批准中移除",
    "markAsPendingValidation": "标记为待验证",
    "solutionLines": "解决方案行",
    "solutions": "解决方案",
    "createOpportunity": "创建新机会",
    "updateOpportunity": "更新机会",
    "newOpportunity": "新机会",
    "newOpportunityDescription": "创建一个新的商业机会",
    "forMarketInsight": "针对: {{name}}",
    "lockedFromMarketInsight": "从市场洞察筛选器中锁定",
    "researchContext": "研究背景",
    "researchContextDescription": "链接市场洞察以用作 AI 生成的背景",
    "linkMarketInsight": "链接市场洞察",
    "linkMarketInsightDescription": "选择一个处理过的市场洞察作为 AI 生成的研究背景。",
    "noProcessedMarketInsights": "没有可用的处理过的市场洞察。请先运行市场洞察。",
    "noMatchingMarketInsights": "没有市场洞察与您的搜索匹配。",
    "opportunity": {
      "sectionName": "📋 机会",
      "title": "机会标题",
      "titlePlaceholder": "简短的机会标题 (2-5 个词)...",
      "slug": "别名",
      "slugPlaceholder": "OP-SECTOR-VERTICAL-01",
      "slugHelper": "自动生成格式: OP-SECTOR-VERTICAL-NN",
      "sector": "行业",
      "sectorPlaceholder": "例如，能源、技术、金融",
      "vertical": "垂直/行业",
      "verticalPlaceholder": "例如，电网、金融科技、农业科技",
      "affectedProcess": "受影响的业务流程",
      "affectedProcessPlaceholder": "哪个业务流程受到影响..."
    },
    "icp": {
      "sectionName": "🎯 ICP",
      "segment": "目标客户细分",
      "segmentPlaceholder": "描述目标客户细分...",
      "size": "可寻址市场总量 (TAM)",
      "sizePlaceholder": "例如，$500M TAM，拉美地区 10,000 家公司",
      "keyRoles": "关键决策者角色",
      "keyRolesPlaceholder": "CTO、CFO、运营总监",
      "keyRolesHelper": "用逗号分隔的角色"
    },
    "problem": {
      "sectionName": "⚠️ 问题",
      "description": "问题陈述",
      "descriptionPlaceholder": "描述此机会所解决的核心问题...",
      "kpiMetric": "当前正在测量的 KPI",
      "kpiMetricPlaceholder": "例如，响应时间、每笔交易成本、错误率",
      "kpiValue": "当前 KPI 值（基线）",
      "kpiValuePlaceholder": "例如，120",
      "kpiUnit": "KPI 测量单位",
      "kpiUnitPlaceholder": "例如，秒、美元、百分比",
      "kpiPeriod": "KPI 测量周期",
      "kpiPeriodPlaceholder": "例如，月平均，2024 年第一季度",
      "painType": "痛点类别",
      "painTypePlaceholder": "成本 | 时间 | 风险 | 质量",
      "painTypeHelper": "此问题所涉及的主要痛点类型",
      "painEstimatedImpact": "预计痛点影响",
      "painEstimatedImpactPlaceholder": "量化影响（例如，$2M 年损失，40% 时间浪费）...",
      "painSource": "痛点来源/引用",
      "painSourcePlaceholder": "此痛点的来源参考或引用"
    },
    "marketWindow": {
      "sectionName": "⏰ 市场窗口",
      "urgencyScore": "紧迫性评分 (1-5)",
      "urgencyScorePlaceholder": "1-5",
      "urgencyScoreHelper": "1 = 低紧迫性，5 = 关键/时间敏感",
      "regulatoryOrContract": "监管/合同驱动因素",
      "regulatoryOrContractPlaceholder": "推动此事的外部监管要求或合同义务...",
      "marketTriggers": "市场触发因素和事件",
      "marketTriggersPlaceholder": "2024 年第二季度新法规\n主要竞争对手推出类似产品\n政府补贴宣布",
      "marketTriggersHelper": "每行一个触发因素"
    },
    "constraints": {
      "sectionName": "🔒 约束",
      "data": "数据可用性和要求",
      "dataPlaceholder": "需要什么数据？是否可用？质量问题？",
      "it": "IT 系统集成",
      "itPlaceholder": "所需集成、遗留系统、所需 API...",
      "compliance": "合规性和监管",
      "compliancePlaceholder": "GDPR、HIPAA、SOC2、行业特定法规...",
      "dataResidency": "数据驻留要求",
      "dataResidencyPlaceholder": "例如，仅限欧盟，仅限美国，仅限拉美",
      "onpremCloud": "部署模型",
      "onpremCloudPlaceholder": "本地 | 云 | 混合",
      "onpremCloudHelper": "本地、云或混合部署"
    },
    "successObjective": {
      "sectionName": "🎯 成功目标",
      "kpiAfter": "实施后的目标 KPI",
      "kpiAfterPlaceholder": "例如，30 秒（从 120 秒基线）",
      "expectedImprovement": "预期改进",
      "expectedImprovementPlaceholder": "例如，减少 75%，增加 3 倍，节省 $1M 年",
      "maxTtvDays": "最大价值实现时间（天）",
      "maxTtvDaysPlaceholder": "例如，90",
      "maxTtvDaysHelper": "看到价值的最大可接受时间",
      "maxPaybackMonths": "最大回收期（个月）",
      "maxPaybackMonthsPlaceholder": "例如，12",
      "maxPaybackMonthsHelper": "回收投资的最大可接受时间"
    },
    "benchmarkGap": {
      "sectionName": "🌍 基准差距",
      "notableCases": "显著参考案例",
      "notableCasesPlaceholder": "来自中国、欧盟、美国的显著案例研究，展示了经过验证的解决方案...",
      "gapComparison": "与先进市场的差距",
      "gapComparisonPlaceholder": "当前状态与中国/欧盟/美国领导者相比如何？成本、速度、技术优势...",
      "transferabilityRisks": "可转移性风险",
      "transferabilityRisksPlaceholder": "从其他市场适应解决方案时的风险（文化、监管、基础设施）..."
    },
    "display": {
      "basicInfo": "基本信息",
      "description": "描述",
      "aiContext": "AI派生的上下文",
      "affectedProcess": "受影响的流程",
      "idealCustomerProfile": "理想客户画像",
      "segment": "细分",
      "marketSize": "市场规模",
      "keyRoles": "关键角色",
      "problemDefinition": "问题定义",
      "currentKPI": "当前KPI",
      "painType": "痛点类型",
      "marketWindow": "市场窗口",
      "urgencyScore": "紧迫性评分",
      "regulatoryContract": "监管/合同",
      "marketTriggers": "市场触发因素",
      "constraints": "约束",
      "data": "数据",
      "itIntegration": "IT集成",
      "compliance": "合规性",
      "dataResidency": "数据驻留",
      "successObjectives": "成功目标",
      "targetKPI": "目标KPI",
      "expectedImprovement": "预期改善",
      "maxTTV": "最大TTV",
      "maxPayback": "最大回收",
      "benchmarkGapAnalysis": "基准与差距分析",
      "notableCases": "显著案例",
      "gapComparison": "差距比较",
      "transferabilityRisks": "可转移性风险",
      "chinaSignals": "市场信号",
      "rootCauses": "根本原因",
      "currentState": "现状"
    }
  },
  "solutionLines": {
    "itemType": "解决方案路线",
    "generate": "用 AI 生成",
    "add": "添加路线",
    "empty": "尚无解决方案路线。可用 AI 生成，或在已明确策略时自行添加。",
    "generating": "正在生成解决方案路线",
    "generatingDescription": "正在探索可解决该机会的策略，每个角度一条。",
    "analyzing": "正在探索角度...",
    "generateFailed": "无法生成解决方案路线",
    "createFailed": "无法创建解决方案路线",
    "updateFailed": "无法更新解决方案路线",
    "deleteFailed": "无法删除解决方案路线",
    "newTitle": "新建解决方案路线",
    "newDescription": "为策略命名。角度与描述留空时由智能体自动生成；填写任一项则按原样保存。",
    "expanding": "正在补全解决方案路线",
    "expandingDescription": "正在根据该机会推导「{{title}}」的角度与描述。",
    "editTitle": "编辑解决方案路线",
    "editDescription": "修改该策略的名称与描述。",
    "regenerate": "重新生成路线",
    "regenerating": "正在重新生成解决方案路线",
    "regeneratingDescription": "正在重写该路线，并重新推导其下解决方案的类型。",
    "regenerateFailed": "无法重新生成解决方案路线",
    "stats": {
      "lines_one": "{{count}} 条解决方案路线",
      "lines_other": "{{count}} 条解决方案路线"
    },
    "fields": {
      "title": "标题",
      "titlePlaceholder": "例如：泊位预测调度",
      "angle": "角度",
      "anglePlaceholder": "例如：流程、技术、数据……",
      "description": "描述",
      "descriptionPlaceholder": "做什么，以及为何能从该角度解决问题。"
    }
  },
  "solutions": {
    "generateBulk": "生成 (5)",
    "generating": "正在生成...",
    "title": "解决方案（{{count}}）",
    "addSolution": "添加解决方案",
    "generatingDraft": "生成解决方案草稿",
    "generatingDraftDescription": "AI正在分析机会并生成解决方案...",
    "regenerate": "重新生成",
    "regenerating": "正在重新生成解决方案",
    "regeneratingDescription": "刷新摘要、数据和匹配的初创公司，同时保留标题...",
    "startupsCountTooltip": "匹配的初创公司",
    "startups": "初创公司",
    "partnerArchetype": "合作伙伴原型",
    "partnerArchetypePlaceholder": "例如，无人机硬件OEM",
    "partnerArchetypeHelper": "提供此解决方案的初创公司/合作伙伴类型",
    "solutionType": "解决方案类型",
    "solutionTypePlaceholder": "请选择一项",
    "solutionTypeHelper": "该解决方案与问题字面诉求的距离。",
    "solutionTypes": {
      "direct": "直接解决方案",
      "adjacent_solution": "邻近解决方案",
      "adjacent_technology": "邻近技术"
    },
    "uncategorized": "无解决方案线",
    "noSolutionsInLine": "此线尚无解决方案。",
    "stats": {
      "validated": "{{count}} 已验证",
      "approved": "{{count}} 已批准",
      "rejected": "{{count}} 已拒绝",
      "reports": "{{count}} 报告",
      "avgScore": "平均 {{score}}/100"
    },
    "badges": {
      "report": "报告"
    },
    "editSolution": "编辑解决方案",
    "validationItems": "此解决方案线的验证项目",
    "content": "内容",
    "contentPlaceholder": "输入解决方案内容...",
    "editDescription": "更新解决方案内容",
    "createDescription": "添加新解决方案以验证此解决方案线",
    "create": "创建",
    "update": "更新",
    "dialog": {
      "sections": {
        "basicInfo": "基本信息",
        "coveragePartner": "合作伙伴",
        "solutionDetails": "解决方案详情",
        "citationsScoring": "引用与评分",
        "scoreBreakdown": "评分细分"
      },
      "solutionTitle": "解决方案标题",
      "solutionTitlePlaceholder": "例如，电网操作双胞胎",
      "scope": "范围",
      "scopePlaceholder": "解决方案的功能及其如何解决受影响的流程...",
      "scopeHelper": "流畅书写 — 来源放在下面的证据引用列表中，而不是内联。",
      "technology": "技术",
      "technologyPlaceholder": "技术方法、模式、架构...",
      "technologyHelper": "流畅书写 — 来源放在下面的证据引用列表中，而不是内联。",
      "operation": "操作",
      "operationPlaceholder": "如何操作、部署模型、集成方法...",
      "operationHelper": "流畅书写 — 来源放在下面的证据引用列表中，而不是内联。",
      "businessModel": "商业模式",
      "businessModelPlaceholder": "定价、许可、参与模型...",
      "businessModelHelper": "流畅书写 — 来源放在下面的证据引用列表中，而不是内联。",
      "evidenceCitations": "证据引用",
      "evidenceCitationsPlaceholder": "来源标题 - https://example.com（范围，技术）\n另一个来源 - https://example.com（操作）",
      "evidenceCitationsHelper": "每行一个引用：标题 - url（引用的字段）",
      "totalScore": "总分",
      "totalScorePlaceholder": "87",
      "totalScoreHelper": "所有子分数的总和（最高100）",
      "lineFitScore": "线适配分数",
      "lineFitScorePlaceholder": "25",
      "lineFitScoreHelper": "0-30分",
      "startupFitScore": "初创公司适配分数",
      "startupFitScorePlaceholder": "25",
      "startupFitScoreHelper": "0-30分",
      "dataFeasibilityScore": "数据可行性分数",
      "dataFeasibilityScorePlaceholder": "13",
      "dataFeasibilityScoreHelper": "0-15分",
      "ttvPaybackScore": "TTV/回收分数",
      "ttvPaybackScorePlaceholder": "8",
      "ttvPaybackScoreHelper": "0-10分",
      "transferabilityScore": "可转移性分数",
      "transferabilityScorePlaceholder": "4",
      "transferabilityScoreHelper": "0-5分",
      "businessModelIcpScore": "商业模式/ICP分数",
      "businessModelIcpScorePlaceholder": "7",
      "businessModelIcpScoreHelper": "0-10分"
    }
  },
  "committee": {
      "unnamed": "委员会 {{id}}",
      "errorLoading": "加载委员会时出错：{{message}}",
    "all_committees": "所有委员会",
    "committees": "委员会",
    "pending_pre_committees": "待处理的预委员会",
    "pre_done_committees": "预委员会完成",
    "post_done_committees": "后委员会完成",
    "title": "委员会",
    "subtitle": "审查和管理委员会会议",
    "list_subtitle": "审查和管理投资委员会",
    "view_subtitle": "审查和优先处理准备好的机会",
    "pre_committee_package": "预委员会包",
    "committee_session": "委员会会议",
    "opportunities_label": "机会",
    "solution_lines_label": "解决方案线",
    "validated_opportunities": "已验证的机会",
    "validated_opportunities_subtitle": "来自市场洞察文档的机会",
    "items_count": "{{count}} 项",
    "add_opportunity": "添加",
    "no_committees": "未找到委员会",
    "no_committees_filter": "未找到此状态的委员会",
    "error": "加载委员会失败",
    "error_loading": "加载委员会时出错",
    "pre_date": "预委员会",
    "post_date": "后委员会",
    "pre_date_label": "预",
    "post_date_label": "后",
    "back_to_list": "返回委员会",
    "overview": "概览",
    "total_committees": "{{count}} 个委员会",
    "status": {
      "all": "所有状态",
      "pending_pre": "待处理的预委员会",
      "pre_done": "预委员会完成",
      "post_done": "正在形成",
      "closed": "已关闭"
    },
    "status_label": {
      "pending": "待处理",
      "pre_done": "预完成",
      "completed": "已完成"
    },
    "status_filter": "状态过滤",
    "search_placeholder": "搜索委员会...",
    "generatingReport": "生成预委员会报告",
    "generatingDescription": "请稍等，我们正在编译您的报告...",
    "analyzingContent": "正在分析机会、论点和解决方案...",
    "reportDownloaded": "报告成功下载！",
    "reportError": "请重试或联系支持，如果问题仍然存在。",
    "pre_committee_report": "预委员会报告",
    "post_committee_report": "后委员会报告",
    "report_status": {
      "ready": "准备生成",
      "generated": "报告已生成",
      "approve_first": "批准解决方案以生成报告",
      "no_opportunities": "没有机会可导出"
    },
    "opportunities_count": "{{count}} 个机会",
    "theses_count": "{{count}} 条解决方案线",
    "solutions_count": "{{count}} 个解决方案",
    "generating": "正在生成...",
    "download_report": "下载报告",
    "generate_report": "生成报告",
    "download_current_document": "下载当前文档",
    "regenerate_document": "重新生成文档",
    "package_content": "包内容",
    "package_content_description": "供审查的机会、解决方案线和解决方案",
    "market_insight_opportunities": "市场洞察机会",
    "opportunities_heading": "机会",
    "no_opportunities": "没有机会",
    "no_opportunities_description": "添加机会以将其包含在此委员会审查中。",
    "add_opportunity_title": "添加机会",
    "add_opportunity_dialog_description": "机会待验证，尚未链接到任何委员会。",
    "opportunities_from_insight": "来自市场洞察的机会",
    "notes_saved": "笔记已保存",
    "notes_saved_description": "委员会笔记已成功保存。",
    "notes_error": "保存笔记时出错",
    "post_report_generated": "报告已下载",
    "post_report_downloaded": "您的后委员会报告已生成并下载。",
    "post_report_error": "错误",
    "post_report_error_description": "生成后委员会报告失败。请重试。",
    "decision_saved": "决策已保存",
    "decision_error": "保存决策时出错",
    "decision": {
      "approved": "已批准",
      "rejected": "已拒绝",
      "pending": "待处理",
      "approved_solutions": "已批准的解决方案",
      "rejected_solutions": "已拒绝的解决方案",
      "approved_opportunities": "已批准的机会",
      "rejected_opportunities": "已拒绝的机会",
      "notesPlaceholder": "此解决方案的笔记（自动保存）",
      "opportunityNotesPlaceholder": "此机会的笔记（自动保存）",
      "addNote": "添加笔记",
      "cascadedApproved": "自动批准",
      "cascadedRejected": "自动拒绝",
      "cascadedHint": "与父机会自动批准。点击批准以确认。",
      "cascadedRejectedHint": "与父机会自动拒绝。点击拒绝以确认。",
      "confirmCascadedHint": "确认此自动批准作为您的决策",
      "confirmCascadedRejectHint": "确认此自动拒绝作为您的决策"
    },
    "decisions_description": "对机会和解决方案进行投票",
    "opportunity_notes_placeholder": "为此机会添加委员会笔记...",
    "solution_notes_placeholder": "为此解决方案添加委员会笔记...",
    "decided_count": "{{decided}}/{{total}} 已决定",
    "count_approved": "{{count}} 已批准",
    "count_rejected": "{{count}} 已拒绝",
    "generating_post_committee_report": "生成后委员会报告",
    "minutes_button": "会议记录和转录",
    "minutes_panel_title": "会议记录和转录",
    "minutes_panel_description": "上传会议转录。会议记录会从中自动生成，并可以在关闭委员会之前进行编辑。",
    "minutes_generating": "正在从转录生成会议记录…",
    "minutes_empty_closed": "该委员会未记录会议纪要。",
    "notes_title": "会议记录",
    "notes_description": "从转录自动生成。请在关闭之前审查和编辑。",
    "notes_placeholder": "上传转录以生成会议记录，或在此处写下...",
    "save_minutes": "保存会议记录",
    "transcript_title": "会议转录",
    "transcript_description": "上传会议转录。会议记录会从中自动生成。",
    "transcript_uploaded": "转录已上传",
    "transcript_upload": "上传",
    "transcript_replace": "替换",
    "transcript_lang_es": "西班牙语",
    "transcript_lang_en": "英语",
    "transcript_lang_hint": "会议的主要语言——会议记录是用它写的。混合的其他语言句子会被处理。",
    "validated_elements": "解决方案决策",
    "solution_decisions_description": "对每个解决方案进行投票以确定下一步",
    "no_validated_opportunities": "没有经过验证的机会",
    "no_validated_theses": "没有经过验证的解决方案线",
    "no_validated_solutions": "没有经过验证的解决方案",
    "validated_theses": "解决方案线",
    "validated_solutions": "解决方案",
    "add": "添加",
    "summary": "摘要",
    "market_insights": "市场洞察",
    "no_market_insights": "没有市场洞察",
    "no_market_insights_description": "添加市场洞察以将其纳入本次委员会审查。",
    "add_market_insight": "添加市场洞察",
    "add_market_insight_description": "选择一个市场洞察以添加到本次委员会。",
    "search_market_insights": "搜索市场洞察...",
    "no_available_market_insights": "没有可添加的市场洞察。",
    "no_matching_market_insights": "没有市场洞察与您的搜索匹配。",
    "error_loading_market_insights": "加载市场洞察时出错",
    "add_n_items": "添加 ({{count}})",
    "already_added": "已添加",
    "in_n_committees": "在 {{count}} 个委员会中",
    "validated_label": "已验证",
    "remove_market_insight": "移除市场洞察",
    "remove_market_insight_description": "您确定要从委员会中移除此市场洞察吗？它不会被删除，可以稍后再次添加。",
    "search_opportunities": "搜索机会...",
    "no_available_opportunities": "没有待验证的机会可用。",
    "no_matching_opportunities": "没有机会与您的搜索匹配。",
    "workflow": {
      "title": "委员会工作流程",
      "pending_pre": "待预委员会",
      "pending_pre_desc": "等待预委员会报告",
      "pre_done": "预委员会完成",
      "pre_done_desc": "预报告已准备好，等待后委员会",
      "post_done": "正在形成中",
      "post_done_desc": "决策已最终确定；已批准的机会正在汇总为项目负责人",
      "closed": "已关闭",
      "closed_desc": "完全关闭；每个已批准的机会都分配给了项目负责人",
      "current": "← 当前",
      "not_started": "委员会工作流程尚未开始",
      "not_started_label": "未开始"
    },
    "report": {
        "error_badge": "{{label}}错误",
      "pre_title": "预委员会报告",
      "post_title": "后委员会报告",
      "pre_desc": "预委员会报告总结了会议前的机会和论点",
      "post_desc": "后委员会报告记录了会议后的决策和下一步",
      "error": "{{label}}-委员会报告错误",
      "error_desc": "报告生成失败。点击查看详细信息并重试。",
      "ready": "{{label}}-委员会报告已准备好"
    },
    "decisions_summary": {
      "title": "委员会决策",
      "total": "{{count}} 总计",
      "approved_desc": "机会正在推进",
      "rejected_desc": "机会被拒绝",
      "pending_desc": "等待决策"
    },
    "stats": {
      "total": "总计",
      "total_desc": "系统中创建的委员会总数",
      "pending_pre": "待预",
      "pending_pre_desc": "等待预委员会会议的委员会",
      "pre_done": "预完成",
      "pre_done_desc": "预委员会已完成，等待后委员会",
      "completed": "已完成",
      "completed_desc": "完整的委员会工作流程已完成，最终决策已做出",
      "in_shaping": "正在形成中",
      "in_shaping_desc": "决策已最终确定；已批准的机会正在汇总为项目负责人。",
      "closed": "已关闭",
      "closed_desc": "完全关闭：每个已批准的机会都已分配给项目负责人。",
      "with_decisions": "有决策",
      "with_decisions_desc": "已记录机会决策的委员会"
    },
    "legend": {
      "workflow_stage": "工作流程阶段",
      "workflow_progress": "工作流程进度",
      "report_ready": "报告已准备好",
      "decisions": "决策",
      "clear_filter": "清除筛选",
      "items": "项目",
      "opportunities": "机会",
      "from_insight": "来自市场洞察",
      "pre_meeting_date": "预委员会会议日期",
      "post_meeting_date": "后委员会会议日期",
      "view_details": "查看详情"
    },
    "statusLabel": "状态",
    "report_button": {
      "pre": "预委员会报告",
      "post": "后委员会报告",
      "download_pre": "下载预报告",
      "download_post": "下载后报告",
      "regenerate": "重新生成报告"
    },
    "solutionsLabel": "解决方案",
    "solutionCount_one": "{{count}} 个解决方案",
    "solutionCount_other": "{{count}} 个解决方案",
    "solutionCount": "{{count}} 个解决方案",
    "viewProjectLead": "项目负责人",
    "solutionsHeading": "解决方案",
    "opportunitiesSubtitle": "对机会及其解决方案进行投票。笔记自动保存。",
    "noOpportunitiesYet": "此委员会尚无机会。",
    "noSolutionsYet": "尚无解决方案。添加一个或运行生成器。",
    "actions": {
      "addSolution": "添加解决方案",
      "generateSolutions": "生成解决方案…",
      "editOpportunity": "编辑机会",
      "editSolution": "编辑解决方案",
      "removeFromCommittee": "从委员会中移除"
    },
    "panels": {
      "editOpportunity": "编辑机会",
      "addSolution": "新建解决方案"
    },
    "close": {
      "button": "关闭委员会",
      "alreadyClosed": "委员会已关闭",
      "inPostCommittee": "在后委员会中",
      "title": "关闭委员会",
      "description": "关闭委员会将触发每个已批准机会的项目负责人生成。此操作不可逆。",
      "confirmButton": "关闭委员会",
      "checkPreReport": "预委员会报告已生成",
      "checkPostReport": "后委员会报告已生成",
      "checkTranscript": "转录已上传，会议记录已生成",
      "approvedOpportunitiesLabel": "已批准的机会",
      "noApprovedYet": "尚未批准任何机会 — 关闭将不会产生任何文档。",
      "warning": "这将关闭委员会并为每个已批准的机会触发项目负责人生成。这是不可逆的。",
      "processing": "正在生成文档…"
    }
  },
  "project": {
    "tabs": {
      "solutions": "解决方案",
      "strategy": "策略",
      "clients": "客户",
      "assets": "资产"
    },
    "title": "项目",
    "subtitle": "将验证过的机会管理为项目",
    "new_project": "新项目",
    "edit_project": "编辑项目",
    "no_projects": "未找到项目",
    "back_to_list": "返回项目",
    "not_found": "未找到项目",
    "search_placeholder": "搜索项目...",
    "delete_confirm": "您确定要删除此项目吗？",
    "deleted": "项目已删除",
    "deleted_description": "项目已成功删除。",
    "delete_error": "删除项目时出错",
    "created": "项目已创建",
    "created_description": "项目已成功创建。",
    "create_error": "创建项目时出错",
    "updated": "项目已更新",
    "updated_description": "项目已成功更新。",
    "update_error": "更新项目时出错",
    "archive": "归档",
    "status": {
      "all": "所有状态",
      "draft": "草稿",
      "published": "已发布",
      "published_flag": "已发布（标记）",
      "withApplicants": "有申请者",
      "closed": "已归档",
      "completed": "已完成",
      "idea": "想法",
      "validation": "验证",
      "committee": "委员会",
      "active": "活跃",
      "archived": "已归档",
      "legacy": "遗留",
      "inProgress": "进行中",
      "standby": "待命",
      "discarded": "已丢弃",
      "readyToDeploy": "准备部署",
      "deployed": "已部署"
    },
    "statusReason": {
      "prompt": "您为什么要设置此状态？",
      "placeholder": "原因…"
    },
    "deploy": {
      "cta": "部署",
      "confirmTitle": "部署此项目？",
      "confirmBody": "这会将项目标记为已部署。已部署是最终状态——之后无法更改状态。"
    },
    "strategy": {
      "title": "策略",
      "autosaveHint": "失焦时自动保存",
      "placeholder": "撰写该项目的策略：定位、差异化优势、优先事项、风险……"
    },
    "sections": {
      "basic": "A) 基本信息",
      "detail": "B) 项目详细信息简介",
      "milestones": "里程碑",
      "targeting": "C) 定向",
      "scoring": "D) 评分",
      "publication": "E) 发布"
    },
    "startupContacts": {
      "title": "初创企业外联",
      "description": "跟踪对已批准解决方案所浮现的初创企业的手动外联。随着对话的进展，状态会更新。",
      "addFromList": "从列表中添加",
      "addNew": "添加新",
      "addNewDisabledHint": "全新的初创企业接收即将到来",
      "pickerTitle": "从候选列表中添加初创企业",
      "pickerTitleScoped": "将初创企业添加到 \"{{title}}\"",
      "pickerDescription": "候选者是固定在此项目已批准解决方案中的初创企业。已添加的初创企业会被过滤掉。",
      "pickerDescriptionScoped": "候选者是固定在此解决方案中的初创企业。已添加的初创企业会被过滤掉。",
      "searchPlaceholder": "搜索候选者...",
      "noCandidates": "没有可用的候选初创企业。",
      "noMatches": "没有候选者与您的搜索匹配。",
      "addSuccess": "已添加 {{count}} 个初创企业",
      "addFailed": "未能添加 {{count}} 个初创企业",
      "empty": "尚未附加任何初创企业。使用 \"从列表中添加\" 从已批准的解决方案中提取。",
      "notesPlaceholder": "对话记录...",
      "contactedAt": "首次联系",
      "showExcluded": "显示已排除（{{count}}）",
      "hideExcluded": "隐藏已排除（{{count}}）",
      "status": {
        "does_not_exist": "不存在",
        "pending_contact": "待联系",
        "negotiating": "洽谈中",
        "agreed": "已确认",
        "dropped": "已放弃"
      }
    },
    "startupKanban": {
      "title": "初创企业外联。",
      "description": "按解决方案分组。随着对话的推进，将初创企业拖动到面板上——状态会立即保存。",
      "empty": "还没有初创企业。使用“从列表中添加”以从已批准的解决方案中提取。",
      "drag": "拖动以更改状态",
      "toggleNotes": "备注",
      "discard": "丢弃",
      "restore": "恢复"
    },
    "fields": {
      "title": "项目标题",
      "sector": "行业",
      "status": "状态",
      "short_description": "简短描述",
      "problem_context": "问题 / 背景",
      "solution_proposal": "建议解决方案",
      "scope_deliverables": "范围和交付物",
      "estimated_duration": "预计持续时间",
      "target_roles": "目标角色",
      "seniority_min": "最低资历（年）",
      "is_published": "发布项目",
      "project_type": "项目类型",
      "vertical": "垂直领域",
      "years": "年",
      "publish_description": "已发布的项目对企业家可见并触发匹配"
    },
    "seniority_scale": {
      "entry": "入口",
      "five": "5年",
      "ten": "10年",
      "fifteen": "15年以上"
    },
    "scoring": {
      "urgency": "紧急程度",
      "difficulty": "难度",
      "priority_score": "优先级得分",
      "bucket": "类别"
    },
    "generate": {
      "button": "生成项目",
      "generating": "正在生成...",
      "success": "已生成项目",
      "success_description": "{{count}} 个项目从已批准的解决方案中创建",
      "error": "生成项目时出错"
    },
    "stats": {
      "total": "总计",
      "published": "已发布",
      "withApplicants": "有申请者",
      "closed": "已关闭",
      "timeToPublish": "发布时间",
      "timeToPublishDesc": "从创建到发布的平均时间",
      "timeToFirstApplicant": "首次申请时间",
      "timeToFirstApplicantDesc": "从发布到首次申请的平均时间",
      "timeToClose": "关闭时间",
      "timeToCloseDesc": "从创建到关闭的平均时间",
      "timeToApplicant": "平均申请时间"
    },
    "buckets": {
      "all": "所有类别",
      "quickWin": "快速胜利",
      "strategicBet": "战略投资",
      "maintain": "维持",
      "defer": "推迟"
    },
    "filters": {
      "statusFilter": "状态过滤器",
      "priorityBucket": "优先级类别",
      "clearFilters": "清除过滤器"
    },
    "actions": {
      "viewDetails": "查看详情",
      "edit": "编辑",
      "delete": "删除",
      "save": "保存更改",
      "findEntrepreneurs": "寻找企业家"
    },
    "list": {
      "assets": "资产",
      "assetsGenerated": "已生成",
      "assetsMissing": "未生成",
      "clients": "客户",
      "priority": "优先级：",
      "created": "创建于",
      "items": "项",
      "errorLoading": "加载项目时出错：{{message}}",
    },
    "matching": {
      "confirm": "为“{{title}}”寻找匹配的企业家？这可能会更新现有匹配。",
      "distribution": "匹配质量分布",
      "sort": "排序",
      "sortScore": "得分",
      "sortName": "名称",
      "sortStarredScore": "已标记 + 得分",
      "sortStarredName": "已标记 + 名称",
      "applications": "申请",
      "noApplications": "还没有申请。",
      "applicationsHint": "申请的企业家将出现在这里。",
      "allMatches": "所有匹配",
      "noMatches": "未找到该项目的匹配。",
      "publishHint": "发布项目以触发企业家匹配。",
      "allApplied": "所有匹配的企业家已申请。",
      "preview": {
        "title": "匹配的企业家",
        "publishRequired": "发布此项目以寻找匹配的企业家",
        "matching": "正在匹配...",
        "refreshMatches": "刷新",
        "runMatching": "寻找匹配",
        "noMatches": "还没有匹配。点击“寻找匹配”以搜索企业家。",
        "showing": "显示 {{shown}} / {{total}} 个匹配"
      },
      "dialog": {
        "confirmTitle": "寻找匹配的企业家",
        "existingMatchesWarning": "现有匹配将被移除并替换",
        "startMatching": "开始匹配",
        "matchingTitle": "寻找企业家",
        "matchingDescription": "正在搜索和评分候选人...",
        "pleaseWait": "这可能需要一些时间。请稍候...",
        "successTitle": "匹配完成",
        "successDescription": "成功找到匹配的企业家。",
        "matchesFound": "匹配的企业家",
        "viewMatches": "查看匹配",
        "errorTitle": "匹配失败",
        "errorDescription": "寻找匹配时发生错误。",
        "retry": "再试一次"
      }
    },
    "publishDialog": {
      "title": "确认发布",
      "description": "在发布之前审核目标标准。已发布的项目对企业家可见并触发匹配。",
      "confirm": "发布并寻找匹配"
    }
  },
  "agentProcessing": {
    "defaultProcessing": "正在处理您的请求...",
    "defaultCompleted": "操作成功完成！",
    "defaultError": "发生错误。请再试一次。",
    "tryAgain": "再试一次",
    "pleaseWait": "请稍候，这可能需要几分钟...",
    "completed": "已完成",
    "error": "错误",
    "minimize": "最小化"
  },
  "backgroundTask": {
    "completed": "已完成",
    "failed": "失败",
    "clickToView": "点击查看",
    "processing": "正在处理",
    "runningInBackground": "在后台运行",
    "unknownError": "未知错误",
    "taskFailed": "后台任务失败",
    "taskLost": "后台任务丢失"
  },
  "solution": {
    "bands": {
      "aligned": "完全匹配的初创企业",
      "suggestions": "推荐",
      "noneAligned": "没有与该解决方案 100% 匹配的初创企业，以下这些或许对您有帮助。"
    },
    "aiContext": "额外数据",
    "generatingReport": "生成解决方案报告",
    "generatingReportDescription": "正在搜索匹配的初创企业并分析适配性...",
    "searchingStartups": "正在搜索和分析中国初创企业...",
    "reportGenerated": "报告生成成功！",
    "regenerateReport": "重新生成报告",
    "generateReport": "生成报告",
    "reportReady": "报告已准备好",
    "devalidate": "从待批准中移除",
    "validate": "验证",
    "details": "解决方案详情",
    "technology": "技术",
    "operation": "运营",
    "scope": "范围",
    "businessModel": "商业模式",
    "solutionScore": "解决方案评分",
    "matchingStartups": "匹配的初创企业",
    "panels": {
      "editSolution": "编辑解决方案"
    },
    "documentView": {
      "selectedStartups": "已选择的初创企业",
      "problem": "P",
      "solution": "S",
      "transferability": "T",
      "problemFull": "问题适配",
      "solutionFull": "解决方案适配",
      "transferabilityFull": "可转移性",
      "overall": "整体适配",
      "addNewStartup": "添加新创业公司"
    },
    "searched": "已搜索",
    "analyzed": "已分析",
    "noStartupsFound": "未找到匹配的初创企业",
    "noReportYet": "尚未生成报告",
    "clickGenerateReport": "点击 \"生成报告\" 搜索匹配的中国初创企业",
    "overall": "整体",
    "problemFit": "问题适配",
    "solutionFit": "解决方案适配",
    "transferability": "可转移性",
    "keyEvidence": "关键证据",
    "problemFitAnalysis": "问题适配分析",
    "solutionFitAnalysis": "解决方案适配分析",
    "transferabilityAnalysis": "可转移性分析",
    "onepagerData": "初创企业一页纸",
    "identity": "身份",
    "valueProposition": "价值主张",
    "marketPosition": "市场定位",
    "businessModelBlock": "商业模式",
    "teamIp": "团队与知识产权",
    "contact": "联系与合作伙伴",
    "evidence": "证据",
    "startupReference": "初创企业参考",
    "opportunityAlignment": "机会对齐",
    "scoreBreakdown": "评分细分",
    "role": "角色",
    "proof": "证明",
    "problem": "问题",
    "icp": "ICP",
    "constraintsAddressed": "解决的约束"
  },
  "editor": {
    "markdownField": "备注",
    "expand": "展开",
    "autosavesOnBlur": "失去焦点时自动保存",
    "characterCount": "{{count}} 个字符"
  },
  "renameDialog": {
    "title": "编辑名称",
    "description": "输入新名称并保存。"
  },
  "projectDocuments": {
    "title": "生成的文档",
    "subtitle": "平台根据项目数据撰写的文档。",
    "brief": "项目简报",
    "briefDescription": "面向投资者和利益相关方的完整备忘录：问题、证据、建议方案以及尚待解答的内容。",
    "profile": "项目概览",
    "profileDescription": "简报的两页版本，面向创业者和建设者。",
    "brochure": "宣传册",
    "brochureDescription": "依据品牌图排版的单页图片，便于一眼展示项目。",
    "availableIn": "可用语言：{{langs}}",
    "noneYet": "尚未生成任何文档。",
    "generatedMeta": "最近生成 · {{date}}",
    "downloadBranding": "下载品牌图",
    "generate": "生成文档",
    "regenerate": "重新生成文档",
    "generatingTitle": "正在生成文档",
    "generatingDesc": "先撰写简报，再据此排版项目概览和宣传册。",
    "working": "正在生成文档…",
    "brandImage": "品牌图片",
    "uploadImage": "上传图片",
    "brandReuseHint": "留空以重用上次上传的品牌板。",
    "brandRequiredHint": "需要品牌图：宣传册将依据它排版。",
    "regenerateHint": "重新生成会替换所有语言的已存文档。",
    "allLanguagesHint": "三份文档仅生成英文版本。请在每份文档的下载菜单中选择其他语言，以按需翻译并缓存。"
  },

  "comments": {
    "title": "评论",
    "add": "添加评论",
    "placeholder": "写下评论…",
    "empty": "暂无评论。",
    "loading": "正在加载评论…",
    "itemType": "评论"
  },
  "common": {
    "dateTime": {
      "datePlaceholder": "选择日期",
      "timePlaceholder": "选择时间",
      "timezoneNoteBrowser": "时间为您所在时区的时间"
    },
    "select": "请选择",
    "expand": "展开",
    "collapse": "收起",
    "pickerCreateHint": "不在列表中 — 从头创建，其档案将自动生成",
    "pickerCreateBadge": "新条目",
    "backToResults": "返回结果",
    "add_n": "添加 ({{count}})",
    "n_selected": "已选 {{count}} 项",
    "select_all": "全选",
    "select_none": "取消全选",
    "created": "创建",
    "hide": "隐藏",
    "lastUpdated": "最后更新",
    "cancel": "取消",
    "save": "保存",
    "create": "创建",
    "saving": "保存中...",
    "working": "处理中...",
    "generateWithAI": "使用AI生成",
    "update": "更新",
    "items": "项",
    "view": "查看",
    "edit": "编辑",
    "delete": "删除",
    "approve": "批准",
    "reject": "拒绝",
    "report": "报告",
    "generate_report": "生成报告",
    "validate": "验证",
    "devalidate": "从待批准中移除",
    "error": "错误",
    "backTo": "返回到 {{name}}",
    "noDataAvailable": "无可用数据",
    "sections": "部分",
    "sources": "来源",
    "expandAll": "全部展开",
    "collapseAll": "全部折叠",
    "back": "返回",
    "unknown": "未知",
    "close": "关闭",
    "generate": "生成",
    "remove": "移除",
    "showLess": "显示更少",
    "showMore": "显示更多",
    "title": "标题",
    "add": "添加",
    "unknown_error": "未知错误",
    "process": "处理",
    "processing": "处理中...",
    "generating": "生成中...",
    "export": "导出",
    "upload": "上传",
    "refresh": "刷新",
    "copy": "复制",
    "open": "打开",
    "filters": "过滤器",
    "submit": "提交",
    "submitting": "提交中...",
    "optional": "(可选)",
    "unlink": "取消链接",
    "searchMarketInsights": "搜索市场洞察..."
  },
  "units": {
    "days": "天",
    "months": "月",
    "cases": "案例",
    "practices": "实践",
    "sources": "来源",
    "integrations": "集成"
  },
  "labels": {
    "target": "目标",
    "delta": "增量",
    "ttv": "TTV"
  },
  "stats": {
    "score": "评分",
    "solutions": "解决方案",
    "ttv": "TTV",
    "payback": "回报期",
    "files": "文件",
    "opportunities": "机会",
    "solutionLines": "解决方案线",
    "references": "参考",
    "icp": "ICP",
    "kpi": "KPI",
    "urgency": "紧迫性"
  },
  "tooltips": {
    "scoreTooltip": "基于适配性、可行性和潜力的整体评分",
    "solutionsTooltip": "该论点的解决方案数量",
    "ttvTooltip": "预计价值实现时间（天）",
    "paybackTooltip": "预计回报期（月）",
    "filesUploaded": "上传的文件用于分析",
    "opportunitiesIdentified": "从分析中识别的投资机会",
    "solutionLinesCreated": "为机会创建的解决方案线（论点）",
    "referencesTooltip": "报告中的外部参考和引用",
    "icpDefined": "理想客户画像已定义",
    "kpiTooltip": "当前问题KPI",
    "urgencyTooltip": "市场紧迫性评分",
    "solutionsDefined": "为此机会定义的解决方案线",
    "marketUrgency": "市场紧迫性",
    "timeSensitivity": "此机会的时间敏感性",
    "totalInsights": "创建的市场研究洞察总数",
    "draftInsights": "已创建但尚未处理的洞察",
    "processingInsights": "当前正在由AI分析的洞察",
    "runningInsights": "当前正在由AI分析的洞察",
    "completedInsights": "分析完成，报告可用",
    "failedInsights": "上次运行失败；未生成报告",
    "validatedInsights": "洞察已审核并验证",
    "withOpportunities": "提取机会的洞察"
  },
  "overview": {
    "totalInsights": "总洞察",
    "draft": "草稿",
    "processing": "运行中",
    "running": "运行中",
    "validated": "已完成",
    "completed": "已完成",
    "failed": "失败",
    "hoverForDetails": "悬停在指标上以获取详细信息",
    "dataProgress": "数据进度：文件 → 报告",
    "validatedStatus": "已验证",
    "marketWindow": "市场窗口",
    "urgency": "紧迫性",
    "constraints": "约束",
    "data": "数据",
    "compliance": "合规性",
    "it": "IT",
    "successObjective": "成功目标",
    "targetKpi": "目标KPI",
    "expectedImprovement": "预期改进",
    "benchmarkGap": "基准差距",
    "notableCases": "显著案例",
    "gapComparison": "差距比较",
    "saveMinutes": "节省分钟",
    "generatingPostReport": "生成委员会后报告",
    "problem": "问题",
    "targetIcp": "目标ICP",
    "keyRoles": "关键角色",
    "ttv": "TTV",
    "payback": "回报",
    "solutionLine": "解决方案线",
    "solutionLines": "解决方案线",
    "solutions": "解决方案",
    "unsavedChanges": "您有未保存的更改",
    "competition": "竞争",
    "valueProposition": "价值主张",
    "marketSize": "市场规模",
    "risks": "风险",
    "size": "规模",
    "kpi": "KPI",
    "chinaBenchmark": "中国对标",
    "problemStatement": "问题陈述"
  },
  "risks": {
    "technical": "技术",
    "operational": "运营",
    "market": "市场",
    "mitigations": "缓解措施",
    "barriersIdentified": "{{count}} 个障碍已识别",
    "strategiesDefined": "{{count}} 个策略已定义",
    "similarCases": "类似案例",
    "payback": "回报"
  },
  "urgencyLevels": {
    "low": "低",
    "medium": "中",
    "high": "高",
    "critical": "关键"
  },
  "evaluation": {
    "title": "机会评估",
    "subtitle": "将批准的机会引导到项目线索中。",
    "approved": "已批准的机会",
    "approve": "批准",
    "reject": "拒绝",
    "sendToShaping": "发送到塑造",
    "queued": "排队等待审核",
    "urgency": "紧迫性",
    "urgent": "紧急",
    "fit": "战略契合",
    "sponsor": "赞助商",
    "solutionsLabel": "解决方案",
    "unassigned": "未分配",
    "solutions_one": "{{count}} 个解决方案",
    "solutions_other": "{{count}} 个解决方案",
    "empty": "该委员会尚无批准的机会。",
    "approvedToast": "机会已批准",
    "rejectedToast": "机会已拒绝",
    "sentToast": "已批准 — 开始塑造",
    "failed": "操作失败"
  },
  "shaping": {
    "title": "塑造中",
    "subtitle": "将批准的机会分组到项目线索中",
    "inbox": "收件箱 / 未分配",
    "newLead": "新容器",
    "createLeadTitle": "新项目线索",
    "createLeadDesc": "为批准的机会创建一个塑造容器。",
    "name": "名称",
    "namePlaceholder": "例如：Q3全球扩展战略",
    "objective": "核心目标",
    "objectivePlaceholder": "这个线索的塑造目标是什么？",
    "sector": "行业",
    "create": "创建",
    "creating": "正在创建…",
    "noMatches": "没有机会与您的搜索匹配。",
    "dropHint": "添加机会以合并到此线索中",
    "mergeDropHint": "将机会拖到这里以合并到 {{title}}",
    "activeContainer": "活动容器",
    "constituents": "组成机会",
    "solutions_one": "{{count}} 个解决方案",
    "solutions_other": "{{count}} 个解决方案",
    "opportunities_one": "{{count}} 个机会",
    "opportunities_other": "{{count}} 个机会",
    "noLeads": "尚无项目线索。创建一个以开始塑造。",
    "emptyLead": "尚无机会。",
    "unassignedEmpty": "没有未分配的批准机会。",
    "remove": "从线索中移除",
    "view": "打开线索",
    "mergeReadiness": "合并准备",
    "generateOnePager": "生成单页",
    "deleteLead": "删除线索",
    "createdToast": "项目线索已创建",
    "deletedToast": "项目线索已删除",
    "deleteLeadFailed": "无法删除项目线索",
    "addFailed": "无法添加机会",
    "moveTo": "移动到线索",
    "moveToNew": "新线索与此",
    "movedToast": "已移动到线索",
    "viewOpportunity": "查看机会",
    "notFound": "未找到项目线索",
    "regenerate": "重新生成",
    "exportPdf": "导出PDF",
    "exportImage": "导出图像",
    "onePager": "单页",
    "onePagerEmpty": "尚无单页 — 从标题生成。",
    "onePagerReady": "单页已准备好",
    "committeeFeedback": "委员会反馈",
    "editOpportunity": "编辑机会",
    "editSolution": "编辑解决方案",
    "viewSolution": "打开解决方案",
    "referenceCases": "参考案例",
    "addSolution": "添加解决方案",
    "solutionItemType": "解决方案",
    "createSolutionTitle": "正在创建解决方案",
    "createSolutionDesc": "AI 正在根据您的输入生成完整的解决方案…",
    "createSolutionFailed": "无法创建解决方案",
    "generateSolutions": "生成解决方案",
    "generatingSolutions": "正在生成解决方案",
    "generatingSolutionsDesc": "AI 正在为此机会生成解决方案…",
    "generateSolutionsFailed": "无法生成解决方案",
    "technicalSpecs": "技术规格",
    "downloadPdf": "下载PDF",
    "specPdf": {
      "generating": "正在生成 PDF",
      "generatingDesc": "正在翻译并生成规格表…"
    },
    "technicalSpecsPlaceholder": "添加技术规格（开放文本）",
    "technicalSpecsExpandedPlaceholder": "在这里写下技术规格…",
    "onePagerGeneratedAt": "生成于 {{date}}",
    "onePagerGenerating": {
      "title": "生成单页",
      "desc": "正在撰写文案并根据此线索创建视觉单页。",
      "status": "生成单页中..."
    },
    "finalized": "已完成",
    "finalize": "批准并创建项目",
    "finalizeConfirm": "批准此线索吗？这将创建一个包含线索数据的项目，准备进行初创企业外展并管理资产。线索将被锁定。",
    "finalizeAction": "批准",
    "finalizedToast": "已批准 — 项目已创建",
    "finalizeFailed": "无法批准项目线索",
    "reject": "拒绝",
    "rejectConfirm": "拒绝此项目线索吗？它将被归档。",
    "rejectedToast": "项目线索已被拒绝",
    "lifecycle": {
      "opportunity": "机会",
      "committee": "委员会",
      "lead": "项目线索",
      "project": "项目"
    },
    "viewProject": "查看项目",
    "solutions": {
      "empty": "该项目暂无机会。项目从其线索物化后即会显示。"
    },
    "assets": {
      "title": "支持资产",
      "upload": "上传",
      "empty": "尚无支持资产。",
      "emptyFolder": "此文件夹为空 — 拖动文件到此处上传。",
      "delete": "删除资产",
      "deleteFolder": "删除文件夹",
      "deleteFolderConfirm": "删除 \"{{name}}\" 及其所有内容？",
      "dropToFolder": "松开文件以上传到“{{folder}}”",
      "dragHint": "将文档拖到此区域即可上传，或点击“上传”。",
      "uploadQueue": {
        "running": "正在上传… {{done}} / {{total}}",
        "finished": "已上传 {{done}} 个 · {{failed}} 个失败",
        "clear": "清除",
        "dismiss": "从列表中移除",
      },
      "uploadErrors": {
        "tooLarge": "文件过大，无法上传。",
        "interrupted": "上传已中断（网络较慢或文件过大）。请重试。",
      },
      "deletedToast": "资产已删除",
      "uploadFailed": "上传失败",
      "moveTo": "移动到文件夹",
      "rootFolder": "根目录",
      "preview": "预览",
      "selectToPreview": "选择一个文件以在此处预览。",
      "noInlinePreview": "此文件类型没有内联预览。",
      "previewFailed": "无法加载预览。",
      "uploadTarget": "上传到",
      "newFolder": "新文件夹",
      "folderName": "文件夹名称"
    },
    "voucher": "视觉凭证",
    "generateVoucher": "生成凭证",
    "voucherEmpty": "生成一个完全视觉化的单页。上传的图像将用作英雄视觉的品牌参考。",
    "voucherHeroAlt": "凭证英雄视觉",
    "voucherGenerating": {
      "title": "生成凭证中",
      "desc": "正在撰写文案，创建英雄视觉并渲染PDF。",
      "status": "生成凭证中..."
    },
    "outreach": {
      "title": "初创企业外展",
      "empty": "跟踪哪些初创企业已联系此线索。开始外展准备草稿项目并从已批准的解决方案中种子候选初创企业。",
      "start": "开始外展",
      "readyToast": "初创企业外展已准备好"
    },
    "startups": {
      "title": "初创企业",
      "label": "初创企业 / 合作伙伴",
      "add": "添加初创企业",
      "itemType": "初创企业",
      "empty": "开始外展以管理此线索的初创企业 — 添加现有或全新的初创企业（dealflow + 2DS + 单页）。"
    },
    "assembly": {
      "solutionsHeading": "解决方案",
      "noSolutions": "尚无解决方案。",
      "assign": "分配",
      "assignTo": "分配给项目线索",
      "prev": "上一个",
      "next": "下一个",
      "toAssign": "{{count}} 待分配",
      "assignedSummary": "{{assigned}} 在 {{leads}} 个线索中",
      "close": "关闭后委员会",
      "closeHint": "{{count}} 仍需分配",
      "closedToast": "后委员会已完成",
      "assigned": "已分配",
      "assignedTo": "已分配给 {{lead}}",
      "unassign": "移除"
    },
    "split": {
      "title": "拆分项目线索",
      "action": "拆分",
      "cta": "拆分",
      "desc": "将 \"{{title}}\" 的解决方案分配到单独的子线索中。",
      "dndDesc": "将解决方案拖入新线索。原始线索保留左侧的内容。",
      "keepBox": "原始线索保留",
      "moveBox": "新线索",
      "newName": "新线索名称",
      "needTwo": "线索需要至少两个解决方案才能拆分。",
      "targets": "目标结构",
      "addTarget": "添加目标",
      "solutions": "可用解决方案",
      "unassigned": "未分配",
      "noSolutions": "没有可分配的已批准解决方案。",
      "confirm": "确认拆分",
      "needAllocation": "至少将一个解决方案分配给目标。",
      "done": "拆分为新的机会",
      "failed": "无法拆分机会"
    },
    "merge": {
      "action": "合并",
      "title": "合并项目线索",
      "dndDesc": "将两个同一行业的项目线索合并为一个。所有机会和解决方案将移入新线索，另一个将被删除。",
      "pickSecond": "选择要合并的线索",
      "result": "新项目线索",
      "noCandidates": "没有其他同一行业的草稿线索可合并。",
      "confirm": "合并",
      "done": "项目线索已合并",
      "failed": "无法合并项目线索"
    },
    "archives": {
      "title": "档案",
      "subtitle": "已完成的项目线索",
      "empty": "尚无已完成的项目线索。",
      "view": "查看"
    },
    "lineage": {
      "split": "拆分",
      "merged": "已合并"
    },
    "assignHint": "拖到项目线索上以分配",
    "postCommittee": {
      "title": "后委员会",
      "subtitle": "审查已关闭的委员会并将其机会转化为线索",
      "workspaceSubtitle": "对该委员会的机会进行分组、拆分和分配到项目线索中",
      "assembleSubtitle": "拆分、合并并将已批准的机会分配到项目线索中",
      "committee": "委员会",
      "pick": "选择委员会",
      "reviewHeading": "审查",
      "shapeHeading": "转化为项目线索",
      "empty": "尚无委员会准备进行后委员会审查。"
    },
    "projectLeads": {
      "title": "项目线索",
      "subtitle": "所有委员会的塑形容器",
      "empty": "尚无项目负责人。从后委员会工作区创建它们。",
      "noMatches": "未找到项目负责人",
      "searchPlaceholder": "搜索项目负责人…",
      "count_one": "{{count}} 项",
      "count_other": "{{count}} 项目",
      "view": "查看",
      "filter": {
        "all": "全部"
      },
      "status": {
        "inProgress": "进行中",
        "standby": "待处理",
        "discarded": "已丢弃",
        "convertedToProject": "已转换为项目"
      }
    },
    "statusReason": {
      "label": "原因",
      "prompt": "您为什么要设置此状态？",
      "placeholder": "原因…"
    },
    "opp": {
      "new": "新机会",
      "title": "新机会",
      "desc": "创建一个已批准的机会，准备在塑形期间分配。",
      "name": "标题",
      "namePlaceholder": "例如：涡轮机的预测性维护",
      "vertical": "垂直领域",
      "verticalPlaceholder": "行业/垂直领域（可选）",
      "createdToast": "机会已创建",
      "failed": "无法创建机会"
    }
  },
  "startups": {
      "noUpdates": "暂无更新",
      "pendingNew_other": "{{count}} 个新",
      "taskOpportunityTitle": "机会：{{name}}",
      "errorLoading": "加载初创公司出错：{{message}}",
    "pageTitle": "初创企业智能",
    "subtitle": "结构化公司档案与AI提取的洞察",
    "backToStartups": "返回初创企业",
    "startupNotFound": "未找到该初创企业",
    "noDataYet": "该初创企业尚无任何分析数据。",
    "processingStatus": "处理中",
    "scopedBy": "筛选依据",
    "allSectors": "所有行业",
    "scopeBySector": "按行业筛选",
    "scoreDetails": "得分详情",
    "scoreBreakdown": "得分细分",
    "scoreFormula": "公式",
    "noScoreBreakdown": "此匹配没有可用的每个维度细分。",
    "marketInsightOverallScoreCaption": "最终AI重新排名的相关性得分",
    "rawDimensionScores": "每个维度的原始语义相似度",
    "dimensions": {
      "combined": "原始语义得分（未区分）",
      "problem_market": "问题与市场",
      "business_execution": "商业与执行"
    },
    "solutionScoreFormula": "整体 = 问题适配、解决方案适配和可转移性的加权组合（每项0-100），由解决方案代理评分。",
    "toasts": {
      "generatingOpportunity": "从单页生成机会…",
      "generateOpportunityFailed": "生成启动失败"
    },
    "stats": {
      "totalStartups": "初创企业总数",
      "completeProfiles": "完整档案",
      "simplified": "简化",
      "pending": "待处理"
    },
    "filters": {
      "profileStatus": "档案状态",
      "allProfiles": "所有档案",
      "allSectors": "所有行业",
      "industrySector": "行业领域",
      "searchByName": "按名称搜索…",
      "showingOf": "显示 {{count}} / {{total}}",
      "clear": "清除",
      "noStartupsFound": "未找到初创企业",
      "clearFilters": "清除筛选"
    },
    "delete": {
      "failed": "无法删除该初创企业",
      "processing": "该初创企业正在处理中，无法删除。",
      "detachWarning": "删除后，该初创企业将从以下内容中移除：{{usages}}。",
      "usedByOtherOrgs": "无法删除：其他组织中有 {{count}} 条记录正在使用该初创企业。",
      "usage": {
        "opportunities": "机会（{{names}}）",
        "project_leads": "项目线索（{{names}}）",
        "projects": "项目（{{names}}）",
        "other_organizations": "其他组织中的 {{count}} 条记录"
      }
    },
    "actions": {
        "generateOpportunity": "生成机会",
      "viewProfile": "查看档案",
      "vectorize": "向量化",
      "generateOnepager": "生成单页"
    },
    "vectorizing": {
      "title": "正在向量化初创企业",
      "desc": "提取维度并存储向量，以便该初创企业可搜索…",
      "status": "正在运行维度提取"
    },
    "onepagerGenerating": {
      "title": "正在生成单页",
      "desc": "通过网络搜索 + LLM 构建完整的 6 块单页…",
      "status": "正在运行单页代理"
    },
    "tabs": {
      "content": "分析",
      "assets": "素材"
    },
    "badges": {
        "noProfile": "无档案",
      "validated": "已验证",
      "draft": "草稿",
      "inProgress": "进行中",
      "failed": "失败",
      "completeOnePager": "完整单页",
      "simplifiedAnalysis": "简化分析",
      "currentData": "当前数据",
      "fullAnalysis": "完整分析"
    },
    "contactPerson": {
      "title": "联系人",
      "name": "姓名",
      "role": "职位",
      "email": "邮箱",
      "phone": "电话",
      "empty": "尚无联系人 — 点击编辑添加。"
    },
    "problemMarket": {
      "editTitle": "编辑问题与解决方案",
      "enrichedContent": "摘要",
      "whatProblem": "解决什么问题",
      "howItSolves": "如何解决",
      "onePerLine": "每行一项"
    },
    "sections": {
      "simplifiedAnalysis": "简化分析（2D）",
      "completeOnePager": "完整单页",
      "problemMarketAnalysis": "问题与解决方案",
      "industryVerticals": "行业垂直领域",
      "businessExecutionAnalysis": "商业-执行分析",
      "companyIdentity": "公司身份与状态",
      "valueProposition": "价值主张与解决方案",
      "marketPosition": "市场定位与竞争",
      "businessModel": "商业模式",
      "teamIp": "团队与知识产权",
      "technologyStack": "技术栈",
      "contactPartnerships": "联系与合作伙伴关系",
      "dataQuality": "数据质量评估",
      "references": "数据来源与参考",
      "linkageSubgraph": "链接子图",
      "verification": "验证",
      "pipelineMetadata": "管道元数据"
    },
    "verification": {
      "sourceValidated": "来源已验证",
      "crossReferenced": "交叉引用",
      "crossReferencedDesc": "在 {{count}} 个外部来源中得到证实。",
      "extractionVerified": "提取已验证"
    },
    "fields": {
      "generationModel": "生成模型",
      "marketUrgency": "市场紧迫性",
      "marketSize": "市场规模",
      "problemSeverity": "问题严重性",
      "revenueStreams": "收入来源",
      "technologyStack": "技术栈",
      "primaryProblem": "主要问题",
      "targetMarket": "目标市场",
      "painPoints": "痛点",
      "industryVerticals": "行业垂直",
      "geographicalFocus": "地理焦点",
      "businessModel": "商业模式",
      "fundingStage": "融资阶段",
      "yearEstablished": "成立年份",
      "keyCustomers": "主要客户",
      "keywords": "关键词",
      "chineseName": "中文名称",
      "englishName": "英文名称",
      "foundationYear": "成立年份",
      "location": "位置",
      "status": "状态",
      "registrationCode": "注册代码",
      "problemAddressed": "解决的问题",
      "solutionFramework": "解决方案框架",
      "valueProposition": "价值主张",
      "productsServices": "产品/服务",
      "industriesServed": "服务行业",
      "marketSegment": "市场细分",
      "targetCustomer": "目标客户",
      "marketTrends": "市场趋势",
      "competitiveLandscape": "竞争格局",
      "growthOpportunities": "增长机会",
      "revenueModel": "收入模型",
      "monetizationStrategy": "货币化策略",
      "fundingRound": "融资轮次",
      "fundingAmount": "融资金额",
      "keyInvestors": "主要投资者",
      "keyMetrics": "关键指标",
      "ceoFounder": "首席执行官/创始人",
      "founderBackground": "创始人背景",
      "teamSize": "团队规模",
      "keyTeamMembers": "关键团队成员",
      "patentsIp": "专利与知识产权",
      "coreTechnologies": "核心技术",
      "aiMlCapabilities": "AI/ML 能力",
      "infrastructure": "基础设施",
      "techDifferentiators": "技术差异化",
      "website": "网站",
      "strategicPartnerships": "战略合作伙伴",
      "analysisConfidence": "分析信心",
      "primarySource": "主要来源",
      "extractionMethod": "提取方法",
      "generatedDate": "生成日期",
      "usedIn": "使用于："
    },
    "processing": {
      "title": "正在处理初创公司",
      "pleaseWait": "这可能需要几分钟。请不要关闭此页面。",
      "progress": "进度",
      "estimatedTime": "~每 25 个初创公司需 10 分钟",
      "errorTitle": "处理失败",
      "defaultError": "处理过程中发生错误。",
      "tryAgain": "再试一次",
      "completedTitle": "处理完成",
      "completedMessage": "所有初创公司已成功处理。",
      "continue": "继续",
      "csvTitle": "正在处理 CSV 文件",
      "csvMessage": "正在使用 AI 提取初创公司维度...",
      "onepagerTitle": "正在生成 OnePagers",
      "onepagerMessage": "正在使用 GPT-5-mini 创建完整的 OnePagers...",
      "insertTitle": "正在插入初创公司",
      "insertMessage": "正在将初创公司保存到数据库并生成嵌入..."
    }
  },
  "applications": {
    "pending": {
      "title": "待处理申请",
      "subtitle": "审核和处理等待批准的企业家申请",
      "refresh": "刷新",
      "cardTitle": "待审核申请",
      "awaitingReview": "{{count}} 个申请等待审核",
      "noPending": "没有待处理的申请",
      "noEmail": "没有电子邮件",
      "profile": "个人资料",
      "rejectionReason": "拒绝原因",
      "rejectionPlaceholder": "为申请人提供反馈...",
      "confirmRejection": "确认拒绝",
      "cancel": "取消",
      "evaluating": "AI 正在评估"
    },
    "approved": {
      "title": "已批准的申请",
      "subtitle": "已获得平台访问权限的企业家",
      "noApproved": "没有已批准的申请",
      "noApprovedDesc": "尚未批准任何申请",
      "approved": "已批准",
      "noHeadline": "没有标题",
      "approvedTime": "已批准 {{time}}",
      "viewDetails": "查看详情"
    },
    "rejected": {
      "title": "被拒绝的申请",
      "subtitle": "已审核并被拒绝的申请",
      "noRejected": "没有被拒绝的申请",
      "noRejectedDesc": "没有申请被拒绝",
      "rejected": "已拒绝",
      "noHeadline": "没有标题",
      "rejectedTime": "已拒绝 {{time}}",
      "reason": "原因：",
      "viewDetails": "查看详情"
    }
  },
  "foundershub": {
    "sidebar": {
      "title": "创始人中心",
      "dashboard": "仪表板",
      "applications": "申请",
      "entrepreneurs": "企业家",
      "projects": "项目"
    },
    "projects": {
      "subtitle": "查看项目及其匹配的企业家"
    },
    "participant": {
      "noAccess": "您的账户无权访问创始人中心。"
    }
  },
  "gaia": {
    "programs": {
      "projectOne": "已分配 1 个项目",
      "projectCount": "已分配 {{total}} 个项目",
      "createdOn": "加入 Gaia：{{date}}",
      "title": "计划",
      "subtitle": "每个计划定义其项目所继承的阶段、活动与交付物。",
      "new": "新建计划",
      "empty": "尚无计划。请创建第一个计划以开始定义阶段。",
      "itemType": "计划",
      "publish": "发布",
      "publishConfirm": "该计划状态将变为「进行中」。",
      "publishedToast": "计划已发布。",
      "publishFailed": "无法发布该计划。",
      "createFailed": "无法创建该计划。",
      "updateFailed": "无法保存该计划。",
      "deleteFailed": "无法删除该计划。"
    },
    "programStatus": {
      "draft": "草稿",
      "active": "进行中",
      "archived": "已归档"
    },
    "programBuilder": {
      "noExpert": "无专家",
      "projects": "已分配项目",
      "projectsEmpty": "目前还没有项目在此计划中运行。",
      "phases": "计划阶段",
      "newPhase": "新建阶段",
      "phasesEmpty": "该计划尚无阶段。请创建第一个阶段以规划其历程。",
      "phaseItemType": "阶段",
      "moveUp": "上移",
      "moveDown": "下移",
      "objective": "目标",
      "activities": "活动",
      "newActivity": "新建活动",
      "activitiesEmpty": "该阶段尚无活动。",
      "activityItemType": "活动",
      "deliverableOne": "1 项交付物",
      "deliverableCount": "{{total}} 项交付物",
      "gate": "关卡",
      "newGate": "新建关卡",
      "gateEmpty": "该阶段尚无关卡。请添加一个以便收尾。",
      "gateItemType": "关卡",
      "locked": "该计划已有 {{total}} 个进行中的项目，因此在此版本中无法修改。唯一还能修改的是每个活动的负责专家，且该更改会应用到所有进行中的项目。",
      "changeExpert": "更换专家"
    },
    "programForm": {
      "newTitle": "新建计划",
      "editTitle": "编辑计划",
      "description": "计划是其项目所继承的阶段、活动与交付物模板。",
      "name": "名称",
      "namePlaceholder": "计划名称",
      "descriptionLabel": "描述",
      "status": "状态",
      "icon": "图标",
      "removeIcon": "移除图标"
    },
    "gateForm": {
      "newTitle": "新建关卡",
      "editTitle": "编辑关卡",
      "description": "关卡用于收尾该阶段：未获批准前项目无法继续推进。",
      "name": "名称",
      "namePlaceholder": "关卡名称",
      "descriptionLabel": "描述",
      "descriptionPlaceholder": "通过该阶段需要验证的内容"
    },
    "projects": {
      "title": "项目",
      "subtitle": "每个项目代表参与计划的一家初创公司或团队。",
      "new": "新建项目",
      "search": "搜索项目...",
      "empty": "尚无项目。请在已配置的计划上创建第一个项目。",
      "noneAssigned": "你尚未被分配到任何项目。",
      "itemType": "项目",
      "program": "计划",
      "phaseCount": "{{completed}}/{{total}} 阶段",
      "createFailed": "无法创建该项目。",
      "updateFailed": "无法保存该项目。",
      "deleteFailed": "无法删除该项目。",
      "editLocked_one": "该项目已有 1 位创业者正在参与，因此其资料不能再修改。项目协调人仍可随时更换，状态操作（暂停、完成、取消）也仍然可用。",
      "editLocked_other": "该项目已有 {{count}} 位创业者正在参与，因此其资料不能再修改。项目协调人仍可随时更换，状态操作（暂停、完成、取消）也仍然可用。"
    },
    "projectStatus": {
      "draft": "草稿",
      "active": "进行中",
      "paused": "已暂停",
      "completed": "已完成",
      "cancelled": "已取消"
    },
    "lifecycle": {
      "blocked": "已锁定",
      "in_progress": "进行中",
      "in_review": "审核中",
      "approved": "已批准",
      "rejected": "已拒绝",
      "completed": "已完成",
      "enabled": "已启用",
      "pending": "待处理"
    },
    "projectForm": {
      "startedAt": "启动日期",
      "startedAtHint": "各阶段的截止日期由此推算，并使用计划定义的时长。",
      "newTitle": "新建项目",
      "editTitle": "编辑项目",
      "description": "定义项目数据并分配相关人员。",
      "name": "名称",
      "namePlaceholder": "项目名称",
      "descriptionLabel": "描述",
      "status": "状态",
      "program": "计划",
      "programPlaceholder": "选择一个计划",
      "programLocked": "项目一旦实例化该计划，就无法再更改计划。"
    },
    "activityForm": {
      "expert": "负责评估的专家",
      "expertPlaceholder": "选择专家",
      "removeExpert": "移除专家",
      "expertHint": "验证该活动的默认专家，适用于所有项目。在此更改会应用到所有进行中的项目。",
      "changeExpertTitle": "更换专家",
      "newTitle": "新建活动",
      "editTitle": "编辑活动",
      "name": "名称",
      "namePlaceholder": "活动名称",
      "descriptionLabel": "描述",
      "descriptionPlaceholder": "团队在此活动中需要完成的工作",
      "deliverables": "交付物",
      "addDeliverable": "添加交付物",
      "deliverablesHint": "每个交付物都可以附带一份参考文档，便于审核人对比预期成果与实际提交的结果。",
      "noDeliverables": "尚未定义交付物。",
      "deliverableNamePlaceholder": "交付物名称",
      "deliverableDescriptionPlaceholder": "交付物描述",
      "removeDeliverable": "删除交付物",
      "documentation": "文档与模板",
      "documentationHint": "添加链接（带超链接的文本），或直接在活动中上传可下载的文件。",
      "noLinks": "尚未添加链接。",
      "linkLabelPlaceholder": "链接文本",
      "addLink": "添加链接",
      "invalidLink": "请输入有效的网址（http 或 https）。",
      "removeLink": "删除链接",
      "uploadFile": "上传可下载文件",
      "removeDocument": "删除文件",
      "saveBeforeUpload": "保存活动时将上传这些文件。",
      "pendingUpload": "保存时上传",
      "uploadFailed": "以下文件上传失败：{{files}}",
      "assignees": "分配到该活动的团队",
      "noAssignees": "尚未为该活动分配人员。"
    },
    "assigneePicker": {
      "inviteMentor": "邀请活动专家",
    },
    "mentorInvite": {
      "hint": "将以负责该活动的成员身份邀请其加入 Gaia 并发送邮件。若其已在该组织中，则仅添加访问权限。",
      "email": "邮箱",
      "fullName": "姓名",
      "submit": "邀请专家",
      "error": "无法邀请该专家。",
      "title": "团队",
      "add": "添加人员",
      "empty": "尚未分配任何人员。",
      "reference": "标记为对接负责人",
      "remove": "移除",
      "pickerHint": "你所在组织中可以承担该工作的人员。",
      "searchPlaceholder": "按姓名或邮箱搜索…",
      "noCandidates": "没有可用人员。"
    },
    "phaseForm": {
      "deadlineOffset": "截止期限",
      "deadlineOffsetPlaceholder": "选择截止期限",
      "deadlineOffsetHint": "阶段的截止日期从上一个关卡关闭之时起算（第一个阶段则从项目启动日期起算）。",
      "newTitle": "新建阶段",
      "editTitle": "编辑阶段",
      "name": "名称",
      "namePlaceholder": "阶段名称",
      "descriptionLabel": "描述",
      "objective": "目标",
      "team": "分配到该阶段的团队",
      "teamEmpty": "尚未有人分配到该阶段。"
    },
    "phases": {
      "dueDate": "截止 {{date}}",
      "setDueDate": "设置截止日期",
      "overdue": "已逾期",
      "editDueDate": "编辑截止日期",
      "manualBadge": "手动",
      "manualHint": "已手动设置——不再自动重新计算。",
      "title": "计划阶段",
      "subtitle": "已完成 {{completed}} / {{total}} 个阶段",
      "activityCount": "{{approved}}/{{total}} 项活动",
      "objective": "阶段目标",
      "empty": "该项目尚未分配计划。",
      "deadlineOffset": {
        "1w": "1 周",
        "2w": "2 周",
        "3w": "3 周",
        "4w": "4 周"
      }
    },
    "activities": {
      "title": "活动",
      "count": "已批准 {{approved}} / {{total}}",
      "more": "查看更多",
      "less": "收起",
      "deliverables": "交付物",
      "documentation": "其他文档",
      "noDeliverables": "未定义交付物。",
      "empty": "该阶段没有活动。",
      "feedbackPlaceholder": "给创业者的反馈...",
      "submissionMessage": "给评审的说明（可选）",
      "submitForReview": "提交活动审核",
      "approve": "批准活动",
      "reject": "拒绝",
      "submissionLabel": "提交说明",
      "feedbackLabel": "评审反馈",
      "expert": "负责评估的专家",
      "noExpert": "未指定",
      "enableFailed": "无法解锁该活动。",
      "dueDateFailed": "无法修改截止日期。"
    },
    "gate": {
      "generateDossier": "生成档案",
      "dossierNotImplemented": "not yet implemented",
      "downloadDossier": "下载档案",
      "uploadReport": "上传关卡后报告",
      "approve": "批准关卡",
      "reject": "拒绝",
      "feedbackPlaceholder": "评审反馈...",
      "blockedHint": "该阶段所有活动获批后，此关卡将自动启用。"
    },
    "deliverables": {
      "status": {
        "pending": "待处理",
        "submitted": "已提交",
        "approved": "已批准",
        "rejected": "已拒绝"
      },
      "upload": "上传文件",
      "submit": "提交审核",
      "approve": "批准",
      "reject": "拒绝",
      "feedbackRequired": "请填写反馈才能拒绝。",
      "needsFileTooltip": "该交付物至少需要一个文件。",
      "reorder": "重新排序",
      "empty": "尚无文件。"
    },
    "reviewHistory": {
      "title": "评审历史",
      "readOnly": "此历史记录为只读，无法修改。",
      "empty": "本阶段尚未提出任何评审申请。",
      "activity": "活动",
      "gate": "阶段关口",
      "noRequest": "无关联申请",
      "submitted": "由 {{name}} 于 {{date}} 提交",
      "resolved": "由 {{name}} 于 {{date}} 处理",
      "comment": "备注",
      "feedback": "反馈",
      "unknownPerson": "未识别"
    },
    "activityLog": {
      "empty": "暂无活动记录。",
      "actions": {
        "meeting_convened": "会议已召集",
        "meeting_updated": "会议已修改",
        "meeting_cancelled": "会议已取消",
        "meeting_summary_saved": "会议纪要已保存",
        "meeting_validated": "会议已验证",
        "file_uploaded": "已上传文件",
        "file_removed": "已删除文件",
        "files_reordered": "文件已重新排序",
        "deliverable_submitted": "交付物已提交审核",
        "deliverable_approved": "交付物已批准",
        "deliverable_rejected": "交付物已拒绝",
        "activity_submitted": "活动已提交审核",
        "activity_rejected": "活动已拒绝",
        "activity_approved": "活动已批准",
        "activity_opened": "活动已开启",
        "phase_started": "阶段已开始",
        "phase_completed": "阶段已完成",
        "gate_enabled": "关卡已启用",
        "gate_approved": "关卡已批准",
        "gate_rejected": "关卡已拒绝",
        "post_gate_report_uploaded": "关卡后报告已上传",
        "project_created": "项目已创建",
        "project_activated": "项目已启动",
        "project_completed": "项目已完成",
        "assignment_added": "已分配人员",
        "assignment_removed": "已取消分配人员",
        "due_date_overridden": "截止日期已修改"
      }
    },
    "coordinatorInvite": {
      "invite": "邀请协调员",
      "hint": "该用户将以成员身份受邀加入 Gaia 并收到电子邮件。若其已属于该组织，则仅添加访问权限。",
      "email": "邮箱",
      "fullName": "姓名",
      "submit": "邀请协调员",
      "error": "无法邀请该协调员。"
    },
    "coordinator": {
      "title": "项目协调员",
      "reference": "联系人",
      "assign": "指派",
      "override": "变更",
      "inherited": "继承自项目群",
      "assignTitle": "项目协调员",
      "assignHint": "仅显示该项目所属组织的员工。",
      "assignError": "无法指派协调员。",
      "empty": "没有可担任协调员的员工。",
      "emptyPanel": "尚未指派协调员。"
    },
    "evaluators": {
      "title": "专家",
      "empty": "尚未为活动分配专家。"
    },
    "members": {
      "participants": "创业者",
      "team": "团队",
      "add": "添加",
      "addParticipants": "添加参与者",
      "addTeam": "添加团队",
      "participantsHint": "仅显示拥有 Gaia 有效访问权限的创业者。",
      "teamHint": "你所在组织的成员。",
      "searchPlaceholder": "按姓名或邮箱搜索...",
      "empty": "没有可用人员。",
      "emptyParticipants": "尚未分配参与者。",
      "emptyTeam": "尚未分配团队。",
      "inviteEntrepreneur": "邀请创业者",
      "inviteHint": "请先按姓名或邮箱搜索。FoundersHub 中已有的创业者会保留其资料并获得 Gaia 访问权限；新用户将收到电子邮件邀请。",
      "inviteEmail": "邮箱",
      "inviteFullName": "姓名",
      "inviteSuccess": "已成功邀请创业者。",
      "inviteError": "无法邀请该创业者。",
      "addFailed": "无法将该成员加入项目。",
      "removeFailed": "无法将该成员移出项目。",
      "pending": "待处理"
    },
    "participant": {
      "myProjects": "我的项目",
      "myProjectsSubtitle": "你参与的项目。",
      "noProjects": "你尚未被分配到任何项目。",
      "noAccess": "你的账户无权访问 Gaia。"
    },
    "history": {
      "project": "项目记录",
      "phase": "阶段记录"
    },
    "sidebar": {
      "dashboard": "仪表板",
      "projects": "项目",
      "meetings": "会议",
      "contracts": "合同",
      "budgets": "预算与 KPI",
      "programs": "项目",
      "auditLog": "审计日志",
      "evaluations": "评估"
    },
    "dashboard": {
      "title": "GAIA 控制面板",
      "placeholder": "仪表板即将推出"
    },
    "common": {
      "comingSoon": "即将推出"
    },
    "meetingStatus": {
      "convened": "已召集",
      "pending_validation": "待验证",
      "no_validator": "无验证人",
      "validated": "已验证",
      "cancelled": "已取消"
    },
    "meetings": {
      "pageTitle": "会议",
      "subtitle": "您项目的跟进会议。",
      "participantSubtitle": "您受邀参加的会议。",
      "projectBlock": "会议",
      "detail": "会议",
      "itemType": "会议",
      "statAll": "会议",
      "convene": "召集会议",
      "edit": "编辑会议",
      "search": "搜索会议或项目...",
      "filterProject": "所有项目",
      "allProjects": "所有项目",
      "filterStatus": "所有状态",
      "allStatuses": "所有状态",
      "empty": "暂无会议。",
      "emptySearch": "没有符合搜索条件的会议。",
      "participantEmpty": "您没有分配到任何会议。",
      "projectEmpty": "该项目暂无会议。",
      "projectEmptyCanConvene": "暂无会议。请召集第一场会议。",
      "pendingSummary": "待撰写纪要",
      "project": "项目",
      "chooseProject": "选择一个项目",
      "title": "标题",
      "objectives": "目标",
      "dateTime": "日期和时间",
      "pastWarning": "该会议将记录为已举行；不会发送邀请。",
      "location": "链接或地点",
      "attendees": "参会人",
      "selectProjectFirst": "请先选择项目以查看其创业者。",
      "noMembers": "该项目没有分配创业者。",
      "membersError": "无法加载该项目的团队。",
      "requiredFields": "请填写项目、参会人、标题、目标以及日期和时间才能召集会议。",
      "noAttendeesWarning": "没有参会人时，该会议将变为「无验证人」，无人可以验证。",
      "noValidatorHint": "该会议没有账户已激活、可以验证它的创业者。请编辑会议邀请以添加一位。",
      "summary": "纪要",
      "summaryPlaceholder": "写下会议讨论的内容...",
      "summaryMetadata": "撰写人",
      "unknownAuthor": "用户不可用",
      "saveError": "无法保存会议。",
      "summaryError": "无法保存摘要。",
      "cancelError": "无法取消会议。",
      "validateError": "无法验证会议。",
      "noSummary": "尚无纪要。",
      "saveAndNotify": "保存并通知参与者",
      "saveSummary": "保存纪要",
      "requestValidation": "申请验证",
      "validate": "验证会议",
      "validateConfirmTitle": "验证会议",
      "validateNeedsSummary": "组织者添加会议摘要后，你才能验证会议。",
      "validateConfirmDescription": "您确认会议已举行，且纪要反映了讨论内容。该记录作为凭证保存，无法撤销。",
      "validatedAt": "会议验证人",
      "cancelConfirmTitle": "取消会议",
      "cancelConfirmDescription": "该会议将记录为已取消，并会通知受邀的创业者。",
      "loadError": "无法加载该会议。",
      "notAvailable": "会议不可用。",
      "summarySaved": "纪要已保存。",
      "summarySavedValidationRequested": "纪要已保存。已请参会人验证会议。",
      "noCalendarSyncHint": "Gaia 不会接收日历中的回复：若会议邀请在日历中被修改或接受，仍需在此同步更新。创业者的验证用于确认会议已举行，并作为凭证保存。",
      "validatorsTitle": "可验证的参会人",
      "validatorsNone": "目前没有账户已激活的创业者可以验证该会议。",
      "pendingValidationCount_one": "{{count}} 份纪要待验证",
      "pendingValidationCount_other": "{{count}} 份纪要待验证"
    }
  },
  "people": {
    "profile": {
      "title": "人员",
      "manageAccount": "管理账户"
    },
    "sections": {
      "details": "资料",
      "cv": "简历",
      "gaiaProjects": "项目",
      "gaiaDeliverables": "交付物",
      "gaiaMeetings": "会议",
      "foundershubApplication": "申请",
      "foundershubOpportunities": "机会",
      "foundershubApplications": "申请记录"
    },
    "details": {
      "editTitle": "编辑资料"
    },
    "gaia": {
      "projectsEmpty": "没有你可以查看的此人的项目。",
      "deliverablesEmpty": "没有你可以查看的分配给此人的交付物。",
      "meetingsEmpty": "没有你可以查看的此人的会议。",
      "seats": {
        "coordinator": "协调员",
        "evaluator": "专家",
        "team": "团队"
      }
    },
    "foundershub": {
      "openApplication": "打开申请审核",
      "opportunitiesEmpty": "没有你可以查看的此人的开放机会。",
      "applicationsEmpty": "没有你可以查看的此人的申请记录。"
    }
  },
  "users": {
    "errors": {
      "hasGaiaEvidence": "无法删除该用户：其已在 gaia 项目中提交交付物或接受文档，这些记录必须保留。请改为停用该账户。",
      "alreadyMemberWithRole": "此人已以其他角色加入本组织。邀请不会更改角色：请在团队中使用「更改角色」。"
    },
    "title": "用户与权限",
    "myProfileTitle": "我的个人资料",
    "subtitle": "管理员工角色和访问权限",
    "stats": {
      "total": "总员工",
      "admins": "管理员",
      "staff": "项目员工"
    },
    "you": "您",
    "viewProfile": "查看个人资料",
    "editPermissions": "编辑角色与权限",
    "editPermissionsTitle": "编辑角色与权限",
    "editPermissionsDesc": "更新 {{name}} 的角色和访问权限",
    "sendReset": "发送密码重置",
    "sendResetSuccess": "密码重置邮件已发送至 {{email}}",
    "sendResetError": "发送密码重置邮件失败",
    "resendInvite": "重新发送邀请",
    "resendInviteSuccess": "邀请已重新发送至 {{email}}",
    "resendInviteError": "重新发送邀请失败",
    "role": "角色",
    "permissions": "权限",
    "adminSuperuser": "管理员拥有完整的平台访问权限，并绕过所有范围检查。",
    "save": "保存",
    "cancel": "取消",
    "saving": "正在保存...",
    "noUsers": "未找到员工用户",
    "detail": {
      "basicInfo": "基本信息",
      "security": "安全性",
      "username": "用户名",
      "email": "电子邮件",
      "edit": "编辑",
      "saveInfo": "保存",
      "saveInfoSuccess": "用户信息已更新",
      "saveInfoError": "更新用户信息失败",
      "savePermsSuccess": "权限已更新",
      "savePermsError": "更新权限失败",
      "sendResetBtn": "发送重置链接",
      "sendResetDesc": "向 {{email}} 发送密码重置邮件",
      "notFound": "未找到用户",
      "platformAccess": "平台访问权限",
      "noPlatformAccess": "尚未获得任何产品权限"
    }
  },
  "superadmin": {
    "sidebar": {
      "organizations": "组织",
      "users": "用户与权限",
      "roles": "角色与访问"
    },
    "orgs": {
      "title": "组织",
      "subtitle": "管理客户组织及其工具访问",
      "create": "新组织",
      "creating": "正在创建...",
      "createTitle": "创建组织",
      "createDesc": "设置一个新的客户组织并提供工具访问。",
      "createSuccess": "组织 \"{{name}}\" 已创建",
      "createError": "创建组织失败",
      "empty": "尚未有组织",
      "notFound": "未找到组织",
      "tools": "工具与访问",
      "members": "成员",
      "enabled": "已启用",
      "disabled": "已禁用",
      "featuresSaved": "工具访问已更新",
      "featuresSaveError": "更新工具访问失败",
      "enabledRoles": "可分配角色",
      "rolesSaved": "可分配角色已更新",
      "rolesSaveError": "更新可分配角色失败",
      "noRolesEnabled": "没有启用的角色",
      "invitePlatform": "平台",
      "noPlatformsEnabled": "没有启用的平台",
      "invite": "邀请用户",
      "inviting": "正在邀请...",
      "inviteTitle": "邀请用户",
      "inviteDesc": "创建一个新用户并将其添加到 {{org}}。将发送设置电子邮件。",
      "inviteSent": "已向 {{email}} 发送邀请",
      "inviteError": "邀请用户失败",
      "noMembers": "尚无成员",
      "fields": {
        "name": "名称",
        "slug": "标识符",
        "features": "工具"
      }
    },
    "users": {
      "subtitle": "平台范围内的员工角色和访问控制"
    },
    "allUsers": {
      "title": "所有用户",
      "stats": {
        "total": "总计",
        "entrepreneurs": "企业家",
        "staff": "员工",
        "active": "活跃",
        "pending": "待处理",
        "disabled": "已禁用"
      },
      "filters": {
        "search": "按名称或电子邮件搜索...",
        "role": "所有角色",
        "state": "所有状态",
        "clear": "清除筛选器"
      },
      "roleLabels": {
        "entrepreneur": "企业家",
        "superadmin": "超级管理员",
        "orgAdmin": "组织管理员",
        "staff": "所有员工"
      },
      "stateLabels": {
        "active": "活跃",
        "pending": "待处理",
        "disabled": "已禁用"
      },
      "perPage": "每页",
      "table": {
        "empty": "未找到用户"
      },
      "pagination": {
        "showing": "显示 {{from}}–{{to}} 共 {{total}}"
      },
      "deleteSuccess": "用户 \"{{name}}\" 已删除",
      "deleteError": "删除用户失败"
    }
  },
  "expert": {
    "sidebar": {
      "committees": "委员会"
    }
  },
  "mentor": {
    "onboarding": {
      "title": "设置密码",
      "subtitle": "为 {{email}} 激活专家账户",
      "newPassword": "密码",
      "confirmPassword": "确认密码",
      "submit": "激活账户",
      "submitError": "无法激活您的账户。",
      "passwordTooShort": "密码至少需要 8 个字符",
      "passwordMismatch": "两次输入的密码不一致",
      "invalidToken": "链接无效或已过期",
      "invalidTokenDesc": "请联系你的组织重新发送邀请。",
      "backToLogin": "返回登录",
      "successTitle": "一切就绪",
      "successDesc": "您的账户已激活。登录以查看您的项目。"
    }
  },
  "org": {
    "sidebar": {
      "dashboard": "仪表板",
      "team": "团队",
      "platformTerminus": "terminus",
      "platformFoundershub": "founder's hub",
      "platformGaia": "gaia",
      "locations": "位置",
      "sources": "来源"
    },
    "platform": {
      "nav": "组织",
      "title": "{{product}} 组织",
      "subtitle": "{{product}} 的产品权限和平台专属设置",
      "products": {
        "terminus": "terminus",
        "foundershub": "founder's hub",
        "gaia": "gaia"
      },
      "settings": {
        "entitlement": "产品",
        "entitlementDesc": "本组织是否拥有 {{product}} 的使用权",
        "enabled": "已启用",
        "notEnabled": "未启用",
        "organization": "组织 ID",
        "organizationDesc": "每位成员都只属于一个组织",
        "managedNote": "产品使用权由超级管理员管理。成员资格和角色在此按产品管理。",
        "disable": "停用",
        "disableSuccess": "访问权限已停用",
        "disableError": "无法停用访问权限",
        "reactivate": "重新启用",
        "reactivateSuccess": "访问权限已重新启用",
        "reactivateError": "无法重新启用访问权限",
        "grant": "授予访问权限",
        "grantSuccess": "访问权限已授予",
        "grantError": "无法授予访问权限"
      }
    },
    "dashboard": {
      "title": "组织",
      "subtitle": "管理您的团队、权限和专家账户",
      "stats": {
        "totalAdmins": "管理员",
        "totalExperts": "专家",
        "activeExperts": "活跃",
        "pendingExperts": "待处理"
      },
      "currentUser": "您的账户",
      "role": "角色",
      "scopes": "范围",
      "quickLinks": "快速链接",
      "manageTeam": "管理团队",
      "manageTeamDesc": "查看管理员用户，编辑角色和权限"
    },
    "locations": {
      "title": "位置",
      "subtitle": "安排委员会时使用的会议地点",
      "add": "添加位置",
      "empty": "尚无位置。添加一个以安排委员会会议。",
      "name": "名称",
      "namePlaceholder": "例如：总部会议室",
      "address": "地址",
      "addressPlaceholder": "街道，城市（可选）",
      "onlineUrl": "在线网址",
      "onlineUrlPlaceholder": "https://meet…（可选）",
      "editTitle": "编辑位置",
      "addTitle": "新位置",
      "save": "保存",
      "cancel": "取消",
      "deleteTitle": "删除位置？",
      "deleteDescription": "此位置将不再可供委员会选择。",
      "delete": "删除",
      "created": "位置已创建",
      "updated": "位置已更新",
      "deleted": "位置已删除",
      "saveError": "无法保存位置",
      "deleteError": "无法删除位置"
    },
    "team": {
      "title": "团队",
      "subtitle": "管理您的团队，一目了然地查看其访问权限",
      "stats": {
        "total": "总计",
        "experts": "专家",
        "admins": "管理员",
        "members": "成员",
        "entrepreneurs": "创业者",
        "pending": "待处理"
      },
      "roles": {
        "admin": "管理员",
        "member": "成员",
        "entrepreneur": "创业者"
      },
      "filters": { "all": "全部" },
      "allPlatforms": "所有平台",
      "items": "人员",
      "searchPlaceholder": "按姓名、电子邮件或角色搜索...",
      "empty": "没有符合这些筛选条件的团队成员",
      "you": "您",
      "pending": "待接受",
      "expertBadge": "委员会专家",
      "editSectors": "编辑领域",
      "editSectorsTitle": "编辑领域",
      "editSectorsDesc": "该委员会专家熟悉的领域——这是 {{name}} 的资格，而非权限。",
      "sectorsSaved": "领域已更新",
      "sectorsError": "更新领域失败",
      "grantsCount": "{{count}} 项授权",
      "editRole": "更改角色",
      "alreadyMemberWithRole": "{{name}} 已是本组织的{{role}}。邀请不会更改角色：请使用「更改角色」。",
      "editRoleTitle": "更改角色",
      "editRoleDesc": "更新 {{name}} 在本组织中的角色",
      "roleSaved": "角色已更新",
      "roleError": "更新角色失败",
      "save": "保存",
      "cancel": "取消",
      "saving": "正在保存...",
      "noAdmins": "未找到管理员用户",
      "errorLoading": "加载管理员用户时出错：{{message}}",
      "invite": "邀请用户",
      "inviteTitle": "邀请团队成员",
      "inviteDesc": "邀请管理员、成员或创业者。每个人都会获得相应的访问权限和入职流程。",
      "inviteEmail": "电子邮件",
      "inviteFullName": "全名",
      "inviteFullNamePlaceholder": "张三",
      "invitePlatform": "产品",
      "inviteRole": "角色",
      "inviteSubmit": "发送邀请",
      "inviteSending": "正在发送...",
      "inviteSuccess": "已向 {{email}} 发送邀请",
      "inviteError": "邀请用户失败",
      "remove": "从组织中移除",
      "removeTitle": "移除团队成员",
      "removeDesc": "从您的组织中移除 {{name}} ({{email}})？这将永久删除用户账户并撤销其访问权限。",
      "removeConfirm": "移除用户",
      "removing": "正在移除...",
      "removeSuccess": "{{name}} 已从组织中移除",
      "removeError": "移除用户失败",
      "resendInvite": "重新发送邀请",
      "resendInviteSuccess": "邀请已重新发送至 {{email}}",
      "resendInviteError": "重新发送邀请失败",
      "revokeAccess": "移出该平台",
      "revokeAccessTitle": "撤销平台访问权限",
      "revokeAccessConfirm": "撤销访问权限",
      "revokeAccessDesc": "确定撤销 {{name}} 对 {{platforms}} 的访问权限吗？账户不会被删除：其个人资料以及其他组织授予的访问权限均保留，之后仍可重新授予。",
      "revokeAccessSuccess": "{{name}} 已无法访问 {{platforms}}",
      "revokeAccessError": "撤销访问权限失败"
    }
  },
  "allApplications": {
      "projectsLabel": "项目",
      "avatarAlt": "头像",
    "title": "企业家",
    "subtitle": "通过他们的旅程审查和管理企业家",
    "errorLoading": "加载申请时出错：{{message}}",
    "status": {
      "approved": "已批准",
      "approvedDesc": "申请已批准，用户可以访问平台",
      "rejected": "已拒绝",
      "rejectedDesc": "申请未获批准",
      "readyForReview": "待审查",
      "readyForReviewDesc": "通过预评分，等待管理员审查",
      "postScoring": "后评分",
      "postScoringDesc": "已添加管理员备注，后评分评估完成",
      "failedPreScore": "预评分失败",
      "failedPreScoreDesc": "第一次预评分尝试失败，可以重试",
      "processing": "处理中",
      "processingDesc": "AI 预评分评估正在进行中",
      "onboarding": "入职中",
      "onboardingDesc": "正在完成个人资料表单",
      "linkedInPending": "LinkedIn 待处理",
      "linkedInPendingDesc": "等待导入 LinkedIn 个人资料",
      "defaultDesc": "状态待定"
    },
    "stats": {
        "approvalRate": "通过率",
      "total": "总计",
      "totalTooltip": "系统中的申请总数",
      "pendingReview": "待审查",
      "pendingReviewTooltip": "准备进行管理员审查的申请",
      "processing": "处理中",
      "processingTooltip": "正在进行的申请（入职，AI 评估）",
      "approved": "已批准",
      "approvedTooltip": "成功批准的企业家",
      "rejected": "已拒绝",
      "rejectedTooltip": "未获批准的申请"
    },
    "filters": {
      "all": "所有申请",
      "pendingReview": "待审查",
      "processing": "处理中",
      "approved": "已批准",
      "rejected": "已拒绝",
      "statusFilter": "状态过滤器",
      "clearFilters": "清除过滤器",
      "searchPlaceholder": "按姓名或电子邮件搜索...",
      "applicationsCount": "{{count}} 个申请"
    },
    "emptyState": {
      "noApplications": "未找到申请"
    },
    "scores": {
      "pre": "预",
      "post": "后",
      "preScore": "预评分",
      "postScore": "后评分",
      "excellent": "优秀候选人",
      "good": "良好潜力",
      "needsReview": "需要审查"
    },
    "journey": {
      "title": "旅程",
      "journeyTitle": "申请旅程",
      "linkedin": "LinkedIn",
      "profile": "个人资料",
      "preScore": "预评分",
      "review": "审查",
      "decision": "决定"
    },
    "legend": {
      "scoreIndicator": "评分指标",
      "journeyProgress": "旅程进度"
    },
    "actions": {
      "viewApplication": "查看申请",
      "viewFullProfile": "查看完整个人资料"
    }
  },
  "foundersHubDashboard": {
    "title": "创始人中心仪表板",
    "subtitle": "实时洞察企业家申请和指标",
    "backToTerminus": "返回 Terminus",
    "loadingMetrics": "加载指标中...",
    "failedToLoad": "加载仪表板指标失败",
    "noDate": "无日期",
    "metrics": {
      "totalApplications": "申请总数",
      "pendingReview": "待审查",
      "approvalRate": "批准率",
      "avgProcessingTime": "平均处理时间",
      "thisWeek": "本周"
    },
    "charts": {
      "applicationTimeline": "申请时间线（过去 7 天）",
      "dailyBreakdown": "申请状态的每日细分",
      "statusDistribution": "状态分布",
      "currentBreakdown": "当前申请细分",
      "preScoreDistribution": "预评分分布（已批准）",
      "scoreRanges": "已批准企业家的评分范围",
      "recentActivity": "最近活动",
      "latestUpdates": "最新申请更新"
    },
    "pendingApplications": "待处理申请",
    "applicationsAwaitingReview": "等待审查的申请"
  },
  "profileReview": {
    "loading": "正在加载您的个人资料...",
    "title": "审查您的个人资料",
    "subtitle": "我们已从 LinkedIn 导入您的信息。请审查并提交以供批准。",
    "linkedInVerified": "LinkedIn 验证",
    "profileInformation": "个人资料信息",
    "importedFromLinkedIn": "从您的 LinkedIn 个人资料导入的信息",
    "firstName": "名字",
    "lastName": "姓氏",
    "emailAddress": "电子邮件地址",
    "professionalHeadline": "专业头衔",
    "accountCreated": "账户已创建",
    "notAvailable": "不可用",
    "readyToSubmit": "准备提交吗？",
    "reviewDescription": "您的个人资料将由我们的团队审查。通常需要 24-48 小时。批准后您将收到电子邮件。",
    "refreshProfile": "刷新个人资料",
    "submitting": "正在提交...",
    "submitForReview": "提交审核",
    "privacyNotice": "通过提交您的个人资料，您同意我们根据我们的隐私政策处理您的数据。您可以在批准后随时更新或删除您的信息。"
  },
  "userMenu": {
    "profile": "个人资料",
    "settings": "设置",
    "signingOut": "正在注销...",
    "signOut": "注销",
    "notSignedIn": "未登录",
    "signIn": "登录",
    "guest": "访客"
  },
  "login": {
    "signUpLink": "注册",
    "founderPortal": "创始人门户",
    "poweredByVess": "由 vess. 提供支持",
    "contactSupport": "联系支持：",
    "entrepreneurLink": "你是创业者？请从这里登录",
    "entrepreneurHint": "你是创业者？",
    "entrepreneurHintLink": "请从创业者登录入口登录。",
    "errors": {
      "invalidCredentials": "邮箱或密码不正确。",
      "accountNotActivated": "你的账户尚未激活。请使用我们通过邮件发送的邀请链接设置密码，或申请重置密码。",
      "accountDisabled": "此账户已被停用。如果你认为这是错误，请联系你的组织。",
      "emailNotVerified": "你的邮箱尚未验证。请在收件箱中查找我们发送的验证链接，或在登录页面重新申请。",
      "ssoOnly": "此账户通过 SSO 创建。请使用你的身份提供商登录。",
      "passwordLoginDisabled": "此类账户不支持密码登录。请使用邀请中指明的登录方式。",
      "noAccount": "你还没有使用该 LinkedIn 的账户。请先注册。",
      "alreadyRegistered": "你已有使用该 LinkedIn 的账户。请登录。",
      "signupClosed": "此平台未开放 LinkedIn 注册。",
      "oauthFailed": "无法完成 LinkedIn 登录。请再试一次。"
    },
    "forEntrepreneurs": "为企业家和初创公司创始人提供",
    "invalidConfiguration": "配置无效",
    "continueWith": "继续使用 {{provider}}",
    "or": "或",
    "email": "电子邮件",
    "password": "密码",
    "logIn": "登录",
    "lastUsed": "最后使用"
  },
  "projectDetail": {
    "scoreDistribution": {
      "topFit": "最佳匹配",
      "strong": "强",
      "potential": "潜力",
      "low": "低"
    },
    "matchCard": {
      "unknownEntrepreneur": "未知企业家",
      "yearsExperience": "{{years}}+ 年",
      "applied": "已申请",
      "matched": "已匹配",
      "sector": "行业",
      "role": "角色",
      "keywords": "关键词"
    }
  },
  "markdownViewer": {
    "downloadMarkdown": "Markdown (.md)",
    "downloadPdf": "PDF (.pdf)"
  },
  "applicationProfile": {
    "backButton": "申请",
    "noHeadline": "无标题",
    "preScore": "预评分",
    "postScore": "后评分",
    "aiEvaluationSummary": "AI 评估摘要",
    "strengths": "优势",
    "concerns": "关注点",
    "adminReview": "管理员审核",
    "discPersonality": "DISC 人格",
    "selectType": "选择类型...",
    "none": "无",
    "notAssigned": "未分配",
    "notes": "备注",
    "addEvaluationNotes": "添加评估备注...",
    "noNotesYet": "尚无备注",
    "networkCounts": "LinkedIn 网络",
    "connections": "连接",
    "followers": "关注者",
    "connectionsPlaceholder": "例如 500",
    "followersPlaceholder": "例如 1200",
    "notSet": "未设置",
    "networkCountsRequired": "连接和关注者是必需的，且必须大于 0。",
    "profileSummary": "个人资料摘要",
    "fullProfile": "完整个人资料",
    "experience": "经验",
    "education": "教育",
    "status": {
      "approved": "已批准",
      "rejected": "已拒绝",
      "readyForReview": "准备审核",
      "postScoring": "后评分",
      "aiProcessing": "AI 处理"
    },
    "score": {
      "pending": "待处理",
      "excellent": "优秀",
      "good": "良好",
      "needsReview": "需要审核"
    },
    "notesSections": {
      "validacion": "总体评估",
      "perfil": "创业者画像",
      "trayectoria": "职业经历",
      "red": "人脉与社会认可"
    }
  },
  "candidateActions": {
    "adminNotes": "管理员备注",
    "approve": "批准",
    "approveTooltip": "批准申请",
    "alreadyApproved": "申请已被批准",
    "reject": "拒绝",
    "rejectTooltip": "拒绝申请",
    "alreadyRejected": "申请已被拒绝",
    "retriggerPreScore": "重新触发预评分",
    "retriggerPostScore": "重新触发后评分",
    "retriggerLinkedin": "重新抓取 LinkedIn",
    "resetToInitial": "重置为初始状态",
    "notesDialog": {
      "title": "管理员备注",
      "description": "为此申请添加评估备注。这些备注在后评分之前是必需的。",
      "notesLabel": "备注",
      "notesPlaceholder": "添加您对该申请的备注...",
      "categories": {
        "validacion": "一般评估",
        "validacionPlaceholder": "面试观察、软技能、动机、红旗...",
        "perfil": "企业家档案",
        "perfilPlaceholder": "企业家资质、融资、观察到的退出...",
        "trayectoria": "职业轨迹",
        "trayectoriaPlaceholder": "职业轨迹、成就、验证的进展...",
        "red": "网络与社交验证",
        "redPlaceholder": "网络质量、可见性、参考..."
      },
      "discLabel": "DISC 人格类型",
      "discPlaceholder": "选择一个 DISC 人格类型...",
      "none": "无",
      "cancel": "取消",
      "saving": "保存中...",
      "saveNotes": "保存备注"
    },
    "rejectDialog": {
      "title": "拒绝申请",
      "description": "请提供拒绝此申请的理由。此反馈将与申请一起存储。",
      "reasonLabel": "拒绝理由",
      "reasonPlaceholder": "为申请人提供反馈...",
      "cancel": "取消",
      "rejectApplication": "拒绝申请"
    },
    "resetDialog": {
      "title": "将申请重置为初始状态",
      "description": "这将把申请重置为 PENDING_LINKEDIN_PARSE 状态，并清除所有数据，包括：",
      "linkedInData": "LinkedIn 个人资料数据",
      "scores": "预评分和后评分评估",
      "adminNotes": "管理员备注",
      "history": "所有批准/拒绝历史",
      "cannotUndo": "此操作无法撤销。",
      "cancel": "取消",
      "resetting": "重置中...",
      "resetApplication": "重置申请"
    }
  },
  "applicationSidebar": {
    "preScoreTitle": "预评分 AI 评估",
    "postScoreTitle": "后评分 AI 评估",
    "preScoreNotCompleted": "预评分评估尚未完成。",
    "preScoreHint": "运行预评分评估以查看 AI 见解。",
    "postScoreNotCompleted": "后评分评估尚未完成。",
    "postScoreHint": "添加管理员备注和 DISC 评估以触发后评分评估。",
    "overallScore": "总体评分",
    "executiveSummary": "执行摘要",
    "subScoresBreakdown": "子评分细分",
    "formula": "公式：",
    "extractedFeatures": "提取的特征",
    "yearsExperience": "工作经验年数：",
    "avgTenure": "平均任期：",
    "founderMonths": "创始人月份：",
    "promotions": "晋升：",
    "keywordsDensity": "关键词密度：",
    "activityItems": "活动项目：",
    "keyStrengths": "关键优势",
    "areasOfConcern": "关注领域",
    "finalScore": "最终评分",
    "finalRecommendation": "最终推荐",
    "executiveSummaryUpdated": "执行摘要（更新）",
    "keyStrengthsFinal": "关键优势（最终评估）",
    "areasOfConcernFinal": "关注领域（最终评估）",
    "finalReasoning": "最终推理",
    "nextSteps": "后续步骤",
    "adminNotesAddressed": "已处理的管理员备注",
    "personalityTraits": "人格特征：",
    "appearanceAssessment": "外观评估：",
    "preScoreConsideration": "预评分考虑："
  },
  "tour": {
    "tooltipReplay": "重新播放引导 tour"
  },
  "auth": {
    "noAccessYet": "你的账户尚无任何板块的访问权限。请让管理员为你分配一个项目。",
    "resetPassword": {
      "title": "设置新密码",
      "subtitle": "为 {{email}} 设置密码",
      "newPassword": "新密码",
      "confirmPassword": "确认密码",
      "submit": "设置密码",
      "passwordMismatch": "密码不匹配",
      "passwordTooShort": "密码必须至少 8 个字符",
      "submitError": "设置密码失败。请再试一次。",
      "invalidToken": "无效或过期的链接",
      "invalidTokenDesc": "此密码重置链接无效或已被使用。",
      "backToLogin": "返回登录",
      "successTitle": "密码已更新",
      "successDesc": "您的密码已设置。您现在可以登录。",
      "usedToken": "此链接已被使用",
      "expiredInvitation": "你的邀请已过期",
      "expiredInvitationDesc": "申请新的邀请，我们会发送到同一邮箱。",
      "requestNewInvitation": "申请新的邀请",
      "reissueNotSent": "无法向你发送新的邀请。请让你的组织重新邀请你。",
      "reissueError": "无法申请新的邀请。请再试一次。",
      "reissuedTitle": "邀请已发送",
      "reissuedDesc": "我们已向你发送新的邀请。请查收邮件并使用新链接。"
    },
    "invitation": {
      "title": "创建你的密码",
      "staffSubtitle": "你已通过 {{email}} 受到邀请。创建密码即可进入。",
      "submit": "创建密码",
      "invalidDesc": "此邀请链接无效或已失效。如果你已创建密码，请直接登录。",
      "usedDesc": "你的账户已激活，请登录。",
      "createdTitle": "密码已创建",
      "createdDesc": "现在可以用你的邮箱和密码登录。"
    },
    "wrapper": {
      "loading": "加载中...",
      "redirecting": "正在重定向到登录...",
      "accessForbidden": "访问被禁止",
      "noPermission": "您没有权限访问此页面。",
      "returnToDashboard": "返回仪表板",
      "featureNotAvailable": "功能不可用",
      "noOrgAccess": "您的组织没有访问此工具的权限。",
      "authError": "身份验证错误"
    }
  },
  "monitoredSources": {
    "title": "监控源",
    "runSyncNow": "立即运行同步",
    "description": "RSS/Atom 源每天读取一次，以发现新兴初创公司并获取有关您的 dealflow 初创公司的新闻。",
    "noSources": "尚无源",
    "active": "活动",
    "paused": "已暂停",
    "pause": "暂停",
    "activate": "激活",
    "remove": "移除",
    "namePlaceholder": "名称（例如 TechCrunch）",
    "urlPlaceholder": "https://example.com/feed.xml",
    "add": "添加",
    "toasts": {
      "sourceAdded": "源已添加",
      "addFailed": "添加源失败",
      "updateFailed": "更新源失败",
      "sourceRemoved": "源已移除",
      "removeFailed": "移除源失败",
      "syncJobTitle": "源监控同步",
      "syncStarted": "同步已开始",
      "syncFailed": "启动同步失败"
    }
  },
  "orgSourcesPage": {
    "title": "源。",
    "subtitle": "您的组织监控的 RSS/Atom 源，以供 dealflow 使用。"
  },
  "entrepreneurProfilePage": {
    "noHeadline": "未提供标题",
    "linkedin": "LinkedIn",
    "preScore": "预评分",
    "postScore": "后评分",
    "tabs": {
      "linkedin": "LinkedIn 个人资料",
      "preScore": "预评分分析",
      "postScore": "后评分分析"
    },
    "linkedinNotAvailable": "LinkedIn 个人资料数据不可用。",
    "preScoreCard": {
      "title": "预评分 AI 评估",
      "description": "基于 LinkedIn 个人资料数据的初步评估"
    },
    "postScoreCard": {
      "title": "后评分 AI 评估",
      "description": "管理员审核和 DISC 分析后的最终评估"
    },
    "preScoreTab": {
      "notCompleted": "预评分评估尚未完成。",
      "runToSeeInsights": "运行预评分评估以查看 AI 洞察。",
      "overallScore": "总体评分",
      "executiveSummary": "执行摘要",
      "subScoresBreakdown": "子评分细分",
      "formula": "公式：",
      "extractedFeatures": "提取的特征",
      "yearsExperience": "工作经验年限：",
      "avgTenure": "平均任期：",
      "founderMonths": "创始人月份：",
      "promotions": "晋升：",
      "keywordsDensity": "关键词密度：",
      "activityItems": "活动项目：",
      "keyStrengths": "关键优势",
      "areasOfConcern": "关注领域"
    },
    "postScoreTab": {
      "notCompleted": "后评分评估尚未完成。",
      "addNotesToTrigger": "添加管理员备注和 DISC 评估以触发后评分评估。",
      "finalScore": "最终评分",
      "finalRecommendation": "最终建议",
      "executiveSummaryUpdated": "执行摘要（更新）",
      "keyStrengthsFinal": "关键优势（最终评估）",
      "areasOfConcernFinal": "关注领域（最终评估）",
      "finalReasoning": "最终推理",
      "nextSteps": "后续步骤",
      "adminNotesAddressed": "管理员备注已处理",
      "personalityTraits": "个性特征：",
      "appearanceAssessment": "外观评估：",
      "preScoreConsideration": "预评分考虑："
    }
  },
  "applicationProfilePage": {
    "title": "申请资料",
    "noHeadline": "未提供标题",
    "linkedinProfile": "LinkedIn 个人资料",
    "preScore": "预评分",
    "postScore": "后评分",
    "preScoreSummary": "预评分摘要",
    "adminReview": {
      "title": "管理员审核",
      "description": "管理员审核的备注和评估"
    },
    "discAssessment": "DISC 评估",
    "selectDiscType": "选择一个 DISC 个性类型...",
    "none": "无",
    "noDiscYet": "尚未添加 DISC 评估。点击编辑以添加评估。",
    "adminNotes": "管理员备注",
    "noNotesYet": "尚未添加管理员备注。点击编辑以添加备注。"
  },
  "entrepreneurProfilePageNew": {
    "breadcrumbEntrepreneurs": "企业家",
    "breadcrumbProfile": "个人资料",
    "entrepreneurFallback": "企业家",
    "present": "当前",
    "viewApplication": "查看申请",
    "about": "关于",
    "experience": "经验",
    "current": "当前",
    "education": "教育",
    "skills": "技能",
    "languages": "语言",
    "certifications": "认证",
    "view": "查看",
    "created": "创建于 {{time}}",
    "updated": "更新于 {{time}}"
  },
  "adminDashboard": {
    "title": "管理员仪表板",
    "welcomeBack": "欢迎回来，{{name}}",
    "refresh": "刷新",
    "signOut": "登出",
    "signingOut": "正在登出...",
    "stats": {
      "pendingApplications": "待处理申请",
      "awaitingReview": "等待审核",
      "adminUser": "管理员用户",
      "administrator": "管理员",
      "status": "状态",
      "online": "在线",
      "systemOperational": "系统正常运行"
    },
    "pendingSection": {
      "title": "待处理的企业家申请",
      "description": "审核并批准或拒绝企业家申请"
    }
  },
  "commandPalette": {
    "startTypingAll": "开始输入以搜索",
    "startTypingEntrepreneurs": "开始输入以搜索企业家",
    "filterByTypeHint": "按类型过滤",
    "searchByIdHint": "按ID搜索",
    "filterByTypeHeading": "按类型过滤",
    "search": "搜索",
    "also": "也",
    "searchByIdOrSlug": "按ID或slug搜索",
    "enterIdOrSlugDesc": "输入UUID或slug以查找特定实体",
    "typeAtLeast2": "输入至少2个字符以搜索",
    "searching": "搜索中...",
    "noResultsFor": "未找到与 \"{{query}}\" 相关的结果",
    "recent": "最近",
    "placeholderEntrepreneurs": "搜索企业家...",
    "placeholderEverything": "搜索所有内容...",
    "placeholderFiltered": "搜索 {{types}}...",
    "placeholderIdOrSlug": "输入ID或slug...",
    "types": {
      "marketInsights": "市场洞察",
      "opportunities": "机会",
      "solutions": "解决方案",
      "startups": "初创公司",
      "projects": "项目",
      "committees": "委员会",
      "entrepreneurs": "企业家",
      "applications": "申请"
    }
  },
  "emoi": {
    "title": "emoi",
    "subtitle": "应用内助手",
    "open": "打开emoi",
    "close": "关闭emoi",
    "placeholder": "请emoi做某事…",
    "send": "发送",
    "contextLabel": "上下文",
    "pending": "思考中…",
    "toolCall": "行动",
    "empty": "请emoi将机会添加到此委员会，或在不离开此页面的情况下管理Terminus。",
    "errorPrefix": "无法连接到emoi",
    "clear": "清除对话"
  },
  "explanations": {
    "solutionScore": {
      "title": "解决方案评分是如何计算的",
      "content": "**解决方案评分**是一个从**0到100**的数字。它不是由AI直接生成的——而是通过服务器以六个加权维度的总和**确定性**计算得出的。\n\n| 维度 | 最大值 | 测量内容 |\n|---|---|---|\n| 线性适配 | 30 | 与解决方案线及其KPI的适配度 |\n| 初创公司适配 | 30 | 产品、技术和商业模式的匹配度 |\n| 数据可行性 | 15 | 所需数据的可用性和IT可行性 |\n| TTV / 回报 | 10 | 价值实现时间≤90天，回报≤12个月 |\n| 可转移性 | 5 | 在其他线上的重用潜力 |\n| 商业模式 / ICP | 10 | 与理想客户画像的定价和运营适配度 |\n\n每个维度的评分最高为其最大值，然后将六个维度的分数相加，得出最终的100分制评分。更高的分数意味着更强、更可行的解决方案。"
    },
    "startupMatch": {
      "title": "初创公司匹配评分是如何计算的",
      "content": "**初创公司匹配**评分是一个从**0到100**的数字，衡量初创公司与该特定解决方案的适配程度。它是三个维度的固定加权平均值，每个维度由AI根据解决方案评分0-10，然后缩放到0-100。\n\n| 维度 | 权重 | 测量内容 |\n|---|---|---|\n| 问题适配 | 45% | 初创公司解决机会问题的能力 |\n| 解决方案适配 | 45% | 初创公司的技术与解决方案的匹配度 |\n| 可转移性 | 10% | 初创公司在欧盟/美国市场的可转移性 |\n\n只有得分**70或以上**的初创公司才会被显示为匹配。更高的分数意味着更强、更可转移的适配。"
    },
    "startupSearchRanking": {
      "title": "初创企业搜索排名的工作原理",
      "content": "初创企业搜索完全基于 **PostgreSQL**，而非向量数据库。初创企业在创建时即存在于 Postgres 中，而其 Qdrant 向量要等到 2DS 和单页生成完成后才出现 —— 因此在 Postgres 中搜索才能立即找到新创建的初创企业。\n\n**搜索范围**\n\n| 字段 | 权重 |\n|---|---|\n| 名称、中文名称 | **A**（最高） |\n| 备用名称、slug | **B** |\n| 2D 问题/市场描述 | **C** |\n| 2D 业务/执行描述、行业 | **D**（最低） |\n\n因此名称匹配的排名高于仅在单页正文中找到的匹配。\n\n**结果排序方式**\n\n1. **完全匹配名称** 优先。\n2. **名称以查询开头** 其次。\n3. **相关性分数**（`ts_rank`）用于其余结果。\n4. **最近更新** 打破剩余的平局，确保排序稳定。\n\n**分数说明**\n\n每行的 0–1 数字是相关性分数，按该结果集中的最佳匹配归一化 —— 排名第一的始终为 1.00。没有分数的行来自行业列表而非排序搜索。\n\n**注意事项**\n\n- 查询词以 OR 组合并支持前缀匹配。\n- 中文名称额外使用子串匹配，因为全文分词无法切分 CJK 文本。\n- 上方的行业开关在服务端过滤；关闭它可搜索所有行业。"
    },
    "marketInsightMatch": {
      "title": "市场洞察匹配评分是如何计算的",
      "content": "将市场洞察与初创公司匹配分为**两个阶段**，这就是为什么上面的评分和下面的评分可能看起来不同的原因。\n\n**1. 语义搜索（按维度）**\n\n市场洞察的标题和问题摘要被嵌入并在Qdrant中与每个初创公司的资料进行搜索，沿着两个独立的维度：\n\n| 维度 | 测量内容 |\n|---|---|\n| 问题与市场 | 初创公司的问题/市场与市场洞察的契合度 |\n| 商业与执行 | 初创公司的商业模式和执行的契合度 |\n\n每个维度保留其最佳的原始余弦相似度分数——这就是下面每个维度显示的内容。\n\n**2. AI重新排序（最终评分）**\n\n第一步的前候选者随后由Cohere根据完整的研究查询进行重新排序，生成显示在初创公司名称上方的**最终匹配评分**。这是一种不同于原始语义搜索的相关性模型，因此它可以比单独的原始每个维度分数更高或更低地评估初创公司。\n\n如果在创建此匹配时无法使用重新排序，则最终评分将回退到原始语义评分——对于在每个维度评分存在之前创建的旧匹配，仅存储一个单一的未区分的原始分数。"
    }
  },
  "clients": {
    "list": {
      "title": "客户",
      "subtitle": "贵组织合作的客户公司",
      "newClient": "新建客户",
      "searchPlaceholder": "搜索客户...",
      "count": "{{count}} 个客户",
      "count_one": "{{count}} 个客户",
      "count_other": "{{count}} 个客户",
      "empty": "暂无客户",
      "errorLoading": "加载客户失败：{{message}}",
      "sectorFilter": "行业",
      "clearFilters": "清除筛选条件"
    },
    "form": {
      "title_create": "新建客户",
      "title_edit": "编辑客户",
      "company": "公司",
      "company_placeholder": "公司名称",
      "industry": "行业",
      "industry_placeholder": "选择行业",
      "web": "网站",
      "web_placeholder": "https://example.com",
      "contact_name": "联系人姓名",
      "contact_name_placeholder": "联系人姓名",
      "contact_role": "职位",
      "contact_role_placeholder": "联系人职位",
      "contact_email": "联系人邮箱",
      "contact_email_placeholder": "contact@example.com",
      "contact_phone": "联系人电话",
      "contact_phone_placeholder": "联系人电话号码"
    },
    "detail": {
      "itemType": "客户"
    },
    "project": {
      "title": "客户",
      "addClient": "添加客户",
      "empty": "该项目尚未关联任何客户。",
      "newClient": "新建客户",
      "attachExisting": "关联现有客户",
      "detach": "取消关联",
      "attachedCount_one": "已关联 {{count}} 个客户",
      "attachedCount_other": "已关联 {{count}} 个客户",
      "attachFailed": "关联客户失败",
      "picker": {
        "title": "关联客户",
        "description": "搜索现有客户，或新建一个客户并关联到该项目。",
        "searchPlaceholder": "搜索客户...",
        "noClients": "暂无客户。",
        "noMatches": "没有符合搜索条件的客户。",
        "addNew": "新建客户",
        "sectorFilterLabel": "按行业筛选"
      }
    }
  },
  fileDropzone: { validation: {"rejected":"已拒绝文件：{{files}}。","singleFile":"请选择一个文件。","fileTooLarge":"文件超过 {{max_mb}} MB 的大小上限。允许的扩展名：{{allowed_extensions}}。","unsupportedFileType":"不支持该文件扩展名。允许的扩展名：{{allowed_extensions}}。最大大小：{{max_mb}} MB。"} },
  gaiaDocuments: {
    loading: "正在加载文档...",
    loadError: "无法加载文档列表。",
    retry: "重试",
    noMatches: "没有符合搜索条件的文档。",
    noPending: "没有待接受的文档。",
    noFilteredResults: "没有符合筛选条件的文档。",
    detail: {"unavailableTitle":"文档不可用","unavailable":"该文档可能已被删除，或未与您共享","loadError":"无法加载此文档。","backToDocuments":"返回文档","backToProfile":"返回我的资料"},
    delete: {"title":"删除文档","acceptedWarning":"“{{document}}”版本 {{version}} 已由 {{name}} 于 {{date}}（马德里时间）接受。删除后，该接受记录将无法再访问。","error":"无法删除此文档。您可以重试。"},
    sidebar: '文档', title: '文档', subtitle: '与 gaia 人员和项目共享的文档。', itemType: '文档',
    search: '搜索文档、人员、邮箱或项目...', perPage: '每页文档数：', empty: '您的范围内尚无文档。',
    stats: { total: '总计', pending: '待接受', accepted: '已接受' }, status: { no_acceptor: '无接受人', pending: '待接受', accepted: '已接受' },
    target: { all: '所有目标', user: '人员', project: '项目' }, category: { all: '所有类别', contract: '合同', support_material: '辅助材料', other: '其他' },
    filter: { no_acceptor: '无接受人', all: '所有接受状态', pending: '待接受', accepted: '已接受', not_required: '无需接受' },
    uploader: { all: '所有上传者' },
    sort: { newest: '最新优先', oldest: '最早优先', name_asc: '名称 A–Z', name_desc: '名称 Z–A' },
    actions: { view: '查看', download: '下载', newVersion: '新版本', reassign: '重新分配', history: '历史记录' },
    fields: { target: '目标', selectTarget: '选择人员或项目', file: '文件', name: '名称', category: '类别', description: '描述', requiresAcceptance: '需要用户明确接受', requiresAcceptanceHint: '接收人或首位项目参与者必须确认。' },
    upload: { title: '上传文档', action: '上传文档', submit: '保存文档', error: '无法上传此文档。' },
    fileDropzone: { dropActive: '将文件放在这里', dropIdle: '将文件拖放到这里', browse: '或从设备中选择', formats: '支持的格式', files: '文件', remove: '移除文件' },
    targetPicker: { loadError: '无法加载目标列表。', title: '选择目标', description: '仅显示您权限范围内的人员和项目。', search: '搜索人员或项目...', empty: '没有可用目标。' },
    version: { title: '上传新版本', submit: '保存新版本', confirmTitle: '确认新版本', confirm: '上传并使接受失效', invalidationWarning: '当前版本由 {{name}} 于 {{date}} 接受。该接受将失效，文档将重新变为待接受。' },
    reassign: { title: '重新分配文档', description: '重新分配不会创建新版本。', current: '当前目标', select: '选择新目标' },
    history: { timezone: '马德里', downloadVersion: '下载版本 {{version}}', noEvents: '暂无活动记录。', noVersions: '暂无版本。', title: '文档历史', versions: '版本', events: '活动', system: '系统' },
    event: { created: '文档已创建', assigned: '文档已分配', accepted: '文档已接受', acceptance_invalidated: '先前的接受已失效', version_uploaded: '已上传新版本', reassigned: '目标已重新分配', deleted: '文档已删除' },
    project: { title: '文档', description: '分配给此项目的材料和文档。', empty: '此项目尚无文档。' },
    profile: { userTitle: '文档', userEmpty: '没有您可以查看的发给此人的文档。', selfEmpty: '尚未有文档与您共享。' },
    preview: { unavailable: '此格式无法在 gaia 内预览。请下载文件查看其内容。' },
    accept: { versionChanged: '文档版本已更改。请查看当前版本并重新确认接受。', error: '无法接受此文档。', noAcceptor: '没有可接受此文档的活跃参与者。文档仍为待接受状态，可以重新分配。', acceptedBy: '由 {{name}} 接受', checkbox: '我已阅读并明确接受本文档的内容', action: '接受文档', confirmTitle: '确认接受', confirmDescription: '您将接受“{{name}}”的版本 {{version}}。您的明确接受将记录在历史中。', confirm: '确认接受' },
  },
  documents: {
    preparing: '正在准备文档...',
    rendering: '正在生成该语言版本...',
    downloading: '正在下载...',
  },
}
